@file:OptIn(ExperimentalMaterial3Api::class, kotlin.io.encoding.ExperimentalEncodingApi::class)
package com.example.monetix

import androidx.compose.animation.AnimatedVisibility
import androidx.compose.animation.Crossfade
import androidx.compose.animation.animateContentSize
import androidx.compose.animation.core.rememberInfiniteTransition
import androidx.compose.animation.core.animateFloat
import androidx.compose.animation.core.infiniteRepeatable
import androidx.compose.animation.core.RepeatMode
import androidx.compose.animation.core.FastOutSlowInEasing
import androidx.compose.animation.core.tween
import androidx.compose.ui.graphics.graphicsLayer
import androidx.compose.animation.expandVertically
import androidx.compose.animation.fadeIn
import androidx.compose.animation.fadeOut
import androidx.compose.animation.shrinkVertically
import androidx.compose.animation.slideInVertically
import androidx.compose.animation.slideOutVertically
import androidx.compose.foundation.BorderStroke
import androidx.compose.foundation.background
import androidx.compose.foundation.border
import androidx.compose.foundation.clickable
import androidx.compose.foundation.interaction.MutableInteractionSource
import androidx.compose.foundation.isSystemInDarkTheme
import androidx.compose.foundation.layout.*
import androidx.compose.foundation.pager.rememberPagerState
import androidx.compose.foundation.rememberScrollState
import androidx.compose.foundation.shape.CircleShape
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.foundation.verticalScroll
import androidx.compose.material.icons.Icons
import androidx.compose.material.icons.outlined.*
import androidx.compose.material.icons.rounded.*
import androidx.compose.material3.*
import androidx.compose.runtime.*
import kotlinx.coroutines.delay
import androidx.compose.ui.Alignment
import com.example.monetix.utils.triggerHapticTick
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.draw.shadow
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.text.style.TextAlign
import androidx.compose.ui.text.style.TextOverflow
import androidx.compose.ui.unit.dp
import kotlin.io.encoding.Base64
import androidx.compose.ui.unit.sp
import androidx.compose.ui.geometry.Offset
import androidx.compose.ui.graphics.graphicsLayer
import androidx.compose.ui.input.nestedscroll.NestedScrollConnection
import androidx.compose.ui.input.nestedscroll.NestedScrollSource
import androidx.compose.ui.input.nestedscroll.nestedScroll
import coil3.ImageLoader
import coil3.compose.setSingletonImageLoaderFactory
import coil3.network.ktor3.KtorNetworkFetcherFactory
import coil3.request.crossfade
import com.example.monetix.db.AccountEntity
import com.example.monetix.db.BudgetEntity
import com.example.monetix.db.CategoryEntity
import com.example.monetix.db.CloudPrefs
import com.example.monetix.db.FavoriteTemplateEntity
import com.example.monetix.db.FinancingEntity
import com.example.monetix.db.MonetixDatabase
import com.example.monetix.db.MonetixRepository
import com.example.monetix.db.PiggyBankEntity
import com.example.monetix.db.RecurringExpenseEntity
import com.example.monetix.db.SavingsGoalEntity
import com.example.monetix.db.TransactionEntity
import com.example.monetix.ui.dialogs.AccountCreateOrEditDialog
import com.example.monetix.ui.dialogs.AddOrTransferDialog
import com.example.monetix.ui.dialogs.BudgetDialog
import com.example.monetix.ui.dialogs.EditTransactionDialog
import com.example.monetix.ui.dialogs.RecurringExpenseDialog
import com.example.monetix.ui.dialogs.SavingsGoalDialog
import com.example.monetix.ui.dialogs.SettingsDialog
import com.example.monetix.ui.screens.DebtManagerScreen
import com.example.monetix.ui.screens.FinancingScreen
import com.example.monetix.ui.screens.HomeScreen
import com.example.monetix.ui.screens.LoginScreen
import com.example.monetix.ui.screens.RecurringScreen
import com.example.monetix.ui.screens.SavingsAndBudgetScreen
import com.example.monetix.ui.screens.StatsScreen
import com.example.monetix.ui.screens.TransactionsScreen
import com.example.monetix.ui.screens.TrashScreen
import com.example.monetix.utils.AutomationEngine
import com.example.monetix.utils.BankNotificationCatcher
import com.example.monetix.utils.FileExporter
import com.example.monetix.utils.StatsEngine
import com.example.monetix.utils.formatEuroFromCents
import com.example.monetix.utils.parseEuroToCents
import com.example.monetix.utils.rememberNotificationScheduler
import dev.gitlive.firebase.Firebase
import dev.gitlive.firebase.auth.auth
import dev.gitlive.firebase.auth.FirebaseAuth
import io.ktor.client.HttpClient
import kotlinx.coroutines.Dispatchers
import kotlinx.coroutines.launch
import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.asStateFlow
import kotlinx.datetime.Clock
import kotlinx.datetime.DatePeriod
import kotlinx.datetime.DayOfWeek
import kotlinx.datetime.Instant
import kotlinx.datetime.LocalDate
import kotlinx.datetime.TimeZone
import kotlinx.datetime.minus
import kotlinx.datetime.plus
import kotlinx.datetime.todayIn
import kotlinx.datetime.toLocalDateTime
import com.example.monetix.ui.theme.MonetixTheme
import androidx.compose.animation.core.Spring
import androidx.compose.animation.core.animateDpAsState
import androidx.compose.animation.core.animateFloatAsState
import androidx.compose.animation.core.spring
import androidx.compose.foundation.Canvas
import androidx.compose.foundation.gestures.detectDragGesturesAfterLongPress
import androidx.compose.foundation.gestures.detectHorizontalDragGestures
import androidx.compose.runtime.saveable.rememberSaveable
import androidx.compose.ui.draw.scale
import androidx.compose.ui.input.pointer.pointerInput
import androidx.compose.ui.platform.LocalDensity
import kotlin.math.roundToInt
import androidx.compose.ui.graphics.Brush
import androidx.compose.ui.hapticfeedback.HapticFeedbackType
import androidx.compose.ui.platform.LocalHapticFeedback
import androidx.compose.ui.unit.IntOffset
import androidx.compose.ui.zIndex
import com.russhwolf.settings.Settings
import dev.gitlive.firebase.firestore.firestore
import androidx.compose.foundation.lazy.LazyColumn
import androidx.compose.foundation.lazy.items
import androidx.compose.ui.text.AnnotatedString
import androidx.lifecycle.Lifecycle
import androidx.lifecycle.LifecycleEventObserver
import androidx.lifecycle.compose.LocalLifecycleOwner
import com.example.monetix.ui.components.MonetixHeader
import com.example.monetix.ui.dialogs.CalculatorDialog
import com.example.monetix.ui.dialogs.FloatingCalculatorPill
import com.example.monetix.ui.screens.rememberRealAvailableBalance
import com.example.monetix.utils.biometricAuth

data class BankNotificationData(val amount: String, val merchant: String, val isIncome: Boolean = false)

object NotificationRouter {
    private val _azioneNotifica = MutableStateFlow<String?>(null)
    val azioneNotifica = _azioneNotifica.asStateFlow()

    var entrateCents: Long = 0L
    var usciteCents: Long = 0L
    var trasferimentiCents: Long = 0L
    var scadenzeOggi: Int = 0

    fun triggerAction(action: String) { _azioneNotifica.value = action }
    fun clearAction() { _azioneNotifica.value = null }
}

interface GoogleAuthenticator {
    suspend fun signIn(auth: FirebaseAuth)
}
var googleAuthenticator: GoogleAuthenticator? = null

enum class Screen { HOME, STATS, SAVINGS, RECURRING, TRANSACTIONS, FINANCINGS, DEBTS }

fun getSalaryDate(year: Int, monthNumber: Int, standardDay: Int, decemberDay: Int, anticipateWeekends: Boolean): LocalDate {
    val baseDay = if (monthNumber == 12) decemberDay else standardDay
    val isLeap = (year % 4 == 0 && (year % 100 != 0 || year % 400 == 0))
    val maxDays = when (monthNumber) {
        2 -> if (isLeap) 29 else 28
        4, 6, 9, 11 -> 30
        else -> 31
    }
    var date = LocalDate(year, monthNumber, baseDay.coerceAtMost(maxDays))
    if (anticipateWeekends) {
        if (date.dayOfWeek == DayOfWeek.SATURDAY) {
            date = date.minus(DatePeriod(days = 1))
        } else if (date.dayOfWeek == DayOfWeek.SUNDAY) {
            date = date.minus(DatePeriod(days = 2))
        }
    }
    return date
}

// 🚀 FUNZIONI PER LO SLITTAMENTO DEL WEEKEND DELL'APP
private fun applyWeekendShift(date: LocalDate): LocalDate {
    return when (date.dayOfWeek) {
        DayOfWeek.SATURDAY -> LocalDate.fromEpochDays(date.toEpochDays() + 2)
        DayOfWeek.SUNDAY -> LocalDate.fromEpochDays(date.toEpochDays() + 1)
        else -> date
    }
}

private fun getShiftedDueDate(baseDay: Int, targetMonth: Int, targetYear: Int): LocalDate {
    var d = baseDay
    var baseDate: LocalDate? = null
    while (baseDate == null && d > 0) {
        try { baseDate = LocalDate(targetYear, targetMonth, d) } catch(e: Exception) { d-- }
    }
    return applyWeekendShift(baseDate!!)
}

private var isCoilInitializedGlobal = false

val LocalHasCustomBackground = staticCompositionLocalOf { false }

@Composable
fun App(
    database: MonetixDatabase,
    shortcutAction: String? = null,
    shortcutTriggerTime: Long = 0L,
    fileExporter: FileExporter,
    initialBankData: BankNotificationData? = null,
    onBankDataConsumed: () -> Unit = {},
    onScheduleDeadline: (hour: Int, minute: Int, enabled: Boolean) -> Unit = { _, _, _ -> },
    onScheduleSummary: (hour: Int, minute: Int, enabled: Boolean) -> Unit = { _, _, _ -> }
) {

    var isCheckingSession by remember { mutableStateOf(true) }

    var navItems by remember {
        mutableStateOf(
            listOf(
                Triple("Home", Icons.Rounded.Dashboard, Icons.Outlined.Dashboard) to Screen.HOME,
                Triple("Stats", Icons.Rounded.Leaderboard, Icons.Outlined.Leaderboard) to Screen.STATS,
                Triple("Risparmi", Icons.Rounded.Savings, Icons.Outlined.Savings) to Screen.SAVINGS,
                Triple("Ricorrenti", Icons.Rounded.SwapHorizontalCircle, Icons.Outlined.SwapHorizontalCircle) to Screen.RECURRING,
                Triple("Movimenti", Icons.Rounded.Toc, Icons.Outlined.Toc) to Screen.TRANSACTIONS,
                Triple("Debiti", Icons.Rounded.Payments, Icons.Outlined.Payments) to Screen.FINANCINGS
            )
        )
    }

    var firebaseUser by remember { mutableStateOf(Firebase.auth.currentUser) }
    var showTrashScreen by remember { mutableStateOf(false) }

    LaunchedEffect(Unit) {
        Firebase.auth.authStateChanged.collect { user ->
            firebaseUser = user
            isCheckingSession = false
        }
    }

    if (isCheckingSession) {
        MonetixTheme {
            Surface(modifier = Modifier.fillMaxSize(), color = MaterialTheme.colorScheme.background) {
                Box(contentAlignment = Alignment.Center, modifier = Modifier.fillMaxSize()) {
                    CircularProgressIndicator(color = MaterialTheme.colorScheme.primary)
                }
            }
        }
        return
    }

    if (firebaseUser == null) {
        MonetixTheme {
            Surface(modifier = Modifier.fillMaxSize(), color = MaterialTheme.colorScheme.background) {
                LoginScreen(onLoginSuccess = { firebaseUser = Firebase.auth.currentUser })
            }
        }
        return
    }

    if (!isCoilInitializedGlobal) {
        setSingletonImageLoaderFactory { context ->
            ImageLoader.Builder(context)
                .components { add(KtorNetworkFetcherFactory(HttpClient())) }
                .crossfade(true)
                .build()
        }
        isCoilInitializedGlobal = true
    }

    val repository = remember { MonetixRepository(database) }
    val homeViewModel = remember { HomeViewModel(repository, database) }
    val scope = rememberCoroutineScope()
    val scheduler = rememberNotificationScheduler()

    var screen by remember { mutableStateOf(Screen.HOME) }
    val pagerState = rememberPagerState(initialPage = 0, pageCount = { 6 })

    val accounts by homeViewModel.accounts.collectAsState()
    val transactions by homeViewModel.transactions.collectAsState()
    val categories by homeViewModel.categories.collectAsState()
    val recurringItems by homeViewModel.recurringItems.collectAsState()
    val financings by homeViewModel.financings.collectAsState()
    val favorites by homeViewModel.favorites.collectAsState()

    val savingsGoals by homeViewModel.savingsGoals.collectAsState()
    val budgets by homeViewModel.budgets.collectAsState()
    val piggyBanks by homeViewModel.piggyBanks.collectAsState()

    val accountingBalancesMap by homeViewModel.accountingBalancesMap.collectAsState()
    val globalBalanceCents by homeViewModel.globalBalanceCents.collectAsState()

    // 🚀 INTERCETTORE WEEKEND: Cattura i movimenti auto-generati nel weekend e li shifta a lunedì
    LaunchedEffect(transactions) {
        transactions.forEach { tx ->
            if (!tx.isDeleted) {
                val isAutoRec = tx.description?.contains("[rec:") == true || tx.merchantKey?.contains("[rec:") == true
                val isAutoFin = tx.description?.contains("[fin:") == true || tx.merchantKey?.contains("[fin:") == true

                // 🚀 FIX: Cerchiamo la parola magica [manual] SIA nella descrizione CHE nel merchantKey!
                val isManual = tx.description?.contains("[manual]", ignoreCase = true) == true ||
                        tx.merchantKey?.contains("[manual]", ignoreCase = true) == true

                if ((isAutoRec || isAutoFin) && !isManual) {
                    val d = try { LocalDate.fromEpochDays(tx.dateEpochDay.toInt()) } catch(e: Exception) { null }
                    if (d != null && (d.dayOfWeek == DayOfWeek.SATURDAY || d.dayOfWeek == DayOfWeek.SUNDAY)) {
                        val shifted = applyWeekendShift(d)
                        if (shifted != d) {
                            val updatedTx = tx.copy(
                                dateEpochDay = shifted.toEpochDays().toLong(),
                                updatedAtEpochMs = Clock.System.now().toEpochMilliseconds()
                            )
                            homeViewModel.saveTransaction(updatedTx)
                        }
                    }
                }
            }
        }
    }

    var showSettingsDialog by remember { mutableStateOf(false) }
    var showDailySummaryDetails by remember { mutableStateOf(false) }
    var userName by remember { mutableStateOf("") }
    var salaryDay by remember { mutableStateOf(27) }
    var decemberSalaryDay by remember { mutableStateOf(20) }
    var anticipateWeekends by remember { mutableStateOf(true) }
    var hideBalances by remember { mutableStateOf(false) }
    var autoSweepEnabled by remember { mutableStateOf(false) }
    var sweepAmountToAsk by remember { mutableStateOf(0L) }
    var showSweepPrompt by remember { mutableStateOf<TransactionEntity?>(null) }
    var sweepDestination by remember { mutableStateOf("SOGNI") }
    var themeMode by remember { mutableStateOf(ThemeMode.SYSTEM) }
    val settings = remember { Settings() }
    val initialAppLock = remember { settings.getBoolean("app_lock_enabled", false) }
    var appLockEnabled by remember { mutableStateOf(initialAppLock) }
    var isAppUnlocked by remember { mutableStateOf(!initialAppLock) }

    val lifecycleOwner = LocalLifecycleOwner.current

    DisposableEffect(lifecycleOwner, appLockEnabled) {
        val observer = LifecycleEventObserver { _, event ->
            if (event == Lifecycle.Event.ON_STOP) {
                if (appLockEnabled) {
                    isAppUnlocked = false
                }
            } else if (event == Lifecycle.Event.ON_START) {
                if (appLockEnabled && !isAppUnlocked) {
                    val bio = biometricAuth
                    if (bio != null && bio.isAvailable()) {
                        bio.authenticate(
                            title = "Sblocco Monetix",
                            subtitle = "Usa l'impronta o il volto per accedere",
                            onSuccess = { isAppUnlocked = true },
                            onError = { err -> println("Biometria all'avvio: $err") }
                        )
                    } else {
                        isAppUnlocked = true
                    }
                }
            }
        }
        lifecycleOwner.lifecycle.addObserver(observer)
        onDispose {
            lifecycleOwner.lifecycle.removeObserver(observer)
        }
    }

    var deadlineHour by remember { mutableStateOf(8) }
    var deadlineMinute by remember { mutableStateOf(30) }
    var deadlineEnabled by remember { mutableStateOf(true) }

    var summaryHour by remember { mutableStateOf(20) }
    var summaryMinute by remember { mutableStateOf(30) }
    var summaryEnabled by remember { mutableStateOf(false) }

    var activeAccountId by remember { mutableStateOf<String?>(null) }
    var saldoDellaCardGrande by remember { mutableStateOf(0L) }
    var safetyBufferCents by remember { mutableStateOf(50000L) }
    var emergencyTargetCents by remember { mutableStateOf(settings.getLong("emergency_fund_target", 500000L)) }

    // 🚀 1. STATI GLOBALI PER IL MENU E LE NOTIFICHE
    var topBarMenuExpanded by rememberSaveable { mutableStateOf(false) }
    var showGlobalCalculator by rememberSaveable { mutableStateOf(false) }
    var isCalculatorMinimized by rememberSaveable { mutableStateOf(false) }
    var calculatorValue by rememberSaveable { mutableStateOf("0") }
    var showNukePrompt by rememberSaveable { mutableStateOf(false) }

    var showGlobalNotifications by rememberSaveable { mutableStateOf(false) }
    var dismissedNotificationIds by remember { mutableStateOf(setOf<String>()) }
    val notificationSheetState = rememberModalBottomSheetState(skipPartiallyExpanded = true)
    val clipboardManager = androidx.compose.ui.platform.LocalClipboardManager.current
    val snackbarHostState = remember { SnackbarHostState() }

    // 🚀 1.5 CALCOLO DELLE DATE E SALUTO
    val today = Clock.System.todayIn(TimeZone.currentSystemDefault())

    var hasSeenMorningGreetingInSession by rememberSaveable { mutableStateOf(false) }
    val greetingText = remember {
        val hour = Clock.System.now().toLocalDateTime(TimeZone.currentSystemDefault()).hour
        when {
            hour in 5..12 -> {
                if (!hasSeenMorningGreetingInSession) {
                    hasSeenMorningGreetingInSession = true
                    "Buongiorno,"
                } else "Bentornato,"
            }
            hour in 13..17 -> "Buon pomeriggio,"
            else -> "Buonasera,"
        }
    }

    val currentMonthSalary = getSalaryDate(today.year, today.monthNumber, salaryDay, decemberSalaryDay, anticipateWeekends)
    val payPeriodStart: LocalDate
    val payPeriodEnd: LocalDate

    if (today < currentMonthSalary) {
        val prevMonthDate = today.minus(DatePeriod(months = 1))
        payPeriodStart = getSalaryDate(prevMonthDate.year, prevMonthDate.monthNumber, salaryDay, decemberSalaryDay, anticipateWeekends)
        payPeriodEnd = currentMonthSalary.minus(DatePeriod(days = 1))
    } else {
        val nextMonthDate = today.plus(DatePeriod(months = 1))
        val nextMonthSalary = getSalaryDate(nextMonthDate.year, nextMonthDate.monthNumber, salaryDay, decemberSalaryDay, anticipateWeekends)
        payPeriodStart = currentMonthSalary
        payPeriodEnd = nextMonthSalary.minus(DatePeriod(days = 1))
    }

    // 🚀 2. CALCOLO GLOBALE DELLE NOTIFICHE
    val todayEpochDaysForAlerts = today.toEpochDays().toLong()
    val accountingPeriodEndAlerts = payPeriodEnd.toEpochDays().toLong()

    val computedAvailableBalance = rememberRealAvailableBalance(
        latest = transactions,
        todayEpoch = todayEpochDaysForAlerts,
        activeAccountId = activeAccountId,
        payPeriodStart = payPeriodStart,
        payPeriodEnd = payPeriodEnd,
        accounts = accounts,
        recurringItems = recurringItems,
        stats = StatsEngine.calculateMonthlyStats(
            startDate = payPeriodStart,
            endDate = payPeriodEnd,
            latestTx = transactions,
            categories = categories,
            recurringItems = recurringItems,
            financingItems = financings,
            activeAccountId = activeAccountId,
            availableBalanceCents = 0L,
            savingsAccountIds = accounts.filter { it.isSavings }.map { it.id }.toSet()
        )
    )

    // Sincronizza la vecchia variabile usata nell'app per mantenere la retrocompatibilità
    LaunchedEffect(computedAvailableBalance) {
        saldoDellaCardGrande = computedAvailableBalance
    }

    val upcomingAlerts = remember(transactions, todayEpochDaysForAlerts, dismissedNotificationIds, recurringItems, accountingPeriodEndAlerts, activeAccountId) {
        val alerts = mutableListOf<Pair<String, TransactionEntity>>()
        val unpaidRecIds = recurringItems.filter { !it.isDeleted && it.isEnabled && it.nextEpochDay <= accountingPeriodEndAlerts && (activeAccountId == null || it.accountId == activeAccountId) }.map { it.id }.toSet()

        transactions.filter { tx ->
            val isBasicValid = !tx.isDeleted &&
                    tx.dateEpochDay > todayEpochDaysForAlerts &&
                    tx.dateEpochDay <= todayEpochDaysForAlerts + 7 &&
                    (tx.reminderDays ?: 0L) >= 0L &&
                    tx.id !in dismissedNotificationIds
            if (!isBasicValid) return@filter false

            val desc = tx.description ?: ""
            val merch = tx.merchantKey ?: ""
            val recId = Regex("\\[rec:([^\\]]+)\\]").find(desc)?.groupValues?.get(1) ?: Regex("\\[rec:([^\\]]+)\\]").find(merch)?.groupValues?.get(1)

            if (recId != null && recId !in unpaidRecIds) return@filter false
            true
        }.forEach { tx ->
            val daysDiff = tx.dateEpochDay - todayEpochDaysForAlerts
            alerts.add((if (daysDiff == 1L) "Domani" else "Tra $daysDiff giorni") to tx)
        }
        alerts.sortedBy { it.second.dateEpochDay }
    }

    val bankNotifsTrigger = BankNotificationCatcher.hasNewNotification
    val bankNotifs = BankNotificationCatcher.pendingQueue.toList()
    val totalNotifications = upcomingAlerts.size + bankNotifs.size
    val hasNotifications = totalNotifications > 0

    LaunchedEffect(Unit) {
        try {
            val storedBuffer = database.settingsQueries.getSetting("safety_buffer").executeAsOneOrNull()
            if (storedBuffer != null) {
                safetyBufferCents = storedBuffer.toLongOrNull() ?: 50000L
            }
        } catch (e: Exception) {}

        try {
            val storedOrder = database.settingsQueries.getSetting("nav_order").executeAsOneOrNull()
            if (!storedOrder.isNullOrBlank()) {
                val savedNames = storedOrder.split(",").map { it.trim() }
                val originalList = listOf(
                    Triple("Home", Icons.Rounded.Dashboard, Icons.Outlined.Dashboard) to Screen.HOME,
                    Triple("Stats", Icons.Rounded.Leaderboard, Icons.Outlined.Leaderboard) to Screen.STATS,
                    Triple("Risparmi", Icons.Rounded.Savings, Icons.Outlined.Savings) to Screen.SAVINGS,
                    Triple("Ricorrenti", Icons.Rounded.SwapHorizontalCircle, Icons.Outlined.SwapHorizontalCircle) to Screen.RECURRING,
                    Triple("Movimenti", Icons.Rounded.Toc, Icons.Outlined.Toc) to Screen.TRANSACTIONS,
                    Triple("Debiti", Icons.Rounded.Payments, Icons.Outlined.Payments) to Screen.FINANCINGS
                )
                val newItems = savedNames.mapNotNull { name -> originalList.find { it.second.name == name } }
                if (newItems.isNotEmpty()) {
                    navItems = (newItems + originalList).distinctBy { it.second }
                }
            }
        } catch (e: Exception) {}
    }

    val userPrefs: CloudPrefs? by homeViewModel.firestore.getPreferenze().collectAsState(initial = null)
    val isSyncComplete by homeViewModel.isInitialSyncComplete.collectAsState()

    LaunchedEffect(userPrefs) {
        userPrefs?.let { prefs ->
            if (prefs.activeAccountId != null) activeAccountId = prefs.activeAccountId
            if (prefs.userName != null) userName = prefs.userName
            if (prefs.salaryDay != null) salaryDay = prefs.salaryDay
            if (prefs.decemberSalaryDay != null) decemberSalaryDay = prefs.decemberSalaryDay
            if (prefs.anticipateWeekends != null) anticipateWeekends = prefs.anticipateWeekends
            if (prefs.hideBalances != null) hideBalances = prefs.hideBalances
            if (prefs.deadlineHour != null) deadlineHour = prefs.deadlineHour
            if (prefs.deadlineMinute != null) deadlineMinute = prefs.deadlineMinute
            if (prefs.deadlineEnabled != null) deadlineEnabled = prefs.deadlineEnabled
            if (prefs.summaryHour != null) summaryHour = prefs.summaryHour
            if (prefs.summaryMinute != null) summaryMinute = prefs.summaryMinute
            if (prefs.summaryEnabled != null) summaryEnabled = prefs.summaryEnabled
            if (prefs.autoSweepEnabled != null) autoSweepEnabled = prefs.autoSweepEnabled
            if (prefs.sweepDestination != null) sweepDestination = prefs.sweepDestination
            if (prefs.themeMode != null) {
                themeMode = try { ThemeMode.valueOf(prefs.themeMode!!) } catch (e: Exception) { ThemeMode.SYSTEM }
            }
            if (prefs.appLockEnabled != null) {
                val cloudLock = prefs.appLockEnabled!!
                appLockEnabled = cloudLock
                settings.putBoolean("app_lock_enabled", cloudLock)
            }
            if (prefs.safetyBufferCents != null) safetyBufferCents = prefs.safetyBufferCents
            if (prefs.emergencyTargetCents != null) {
                emergencyTargetCents = prefs.emergencyTargetCents
                // E per sicurezza di offline, aggiorniamo anche le preferenze interne
                settings.putLong("emergency_fund_target", prefs.emergencyTargetCents)
            }
            if (!prefs.navOrder.isNullOrBlank()) {
                val savedNames = prefs.navOrder.split(",").map { it.trim() }
                val currentNames = navItems.map { it.second.name }

                if (savedNames != currentNames) {
                    val originalList = listOf(
                        Triple("Home", Icons.Rounded.Dashboard, Icons.Outlined.Dashboard) to Screen.HOME,
                        Triple("Stats", Icons.Rounded.Leaderboard, Icons.Outlined.Leaderboard) to Screen.STATS,
                        Triple("Risparmi", Icons.Rounded.Savings, Icons.Outlined.Savings) to Screen.SAVINGS,
                        Triple("Ricorrenti", Icons.Rounded.SwapHorizontalCircle, Icons.Outlined.SwapHorizontalCircle) to Screen.RECURRING,
                        Triple("Movimenti", Icons.Rounded.Toc, Icons.Outlined.Toc) to Screen.TRANSACTIONS,
                        Triple("Debiti", Icons.Rounded.Payments, Icons.Outlined.Payments) to Screen.FINANCINGS
                    )

                    val newItems = savedNames.mapNotNull { name -> originalList.find { it.second.name == name } }
                    val fullNewList = (newItems + originalList).distinctBy { it.second }

                    if (fullNewList.map { it.second.name } != currentNames) {
                        navItems = fullNewList
                        scope.launch {
                            try { database.settingsQueries.insertSetting("nav_order", prefs.navOrder) } catch (e: Exception) {}
                        }
                    }
                }
            }
        }
    }

    var pendingCloudSave by remember { mutableStateOf(false) }

    LaunchedEffect(pendingCloudSave) {
        if (pendingCloudSave) {
            val basePrefs = userPrefs ?: CloudPrefs()
            homeViewModel.firestore.salvaPreferenze(
                basePrefs.copy(
                    activeAccountId = activeAccountId,
                    userName = userName,
                    salaryDay = salaryDay,
                    decemberSalaryDay = decemberSalaryDay,
                    anticipateWeekends = anticipateWeekends,
                    hideBalances = hideBalances,
                    deadlineHour = deadlineHour,
                    deadlineMinute = deadlineMinute,
                    deadlineEnabled = deadlineEnabled,
                    summaryHour = summaryHour,
                    summaryMinute = summaryMinute,
                    summaryEnabled = summaryEnabled,
                    autoSweepEnabled = autoSweepEnabled,
                    sweepDestination = sweepDestination,
                    themeMode = themeMode.name,
                    appLockEnabled = appLockEnabled,
                    safetyBufferCents = safetyBufferCents,
                    navOrder = navItems.joinToString(",") { it.second.name }
                )
            )
            pendingCloudSave = false
        }
    }

    val systemDark = isSystemInDarkTheme()
    val useDarkTheme = when (themeMode) {
        ThemeMode.SYSTEM -> systemDark
        ThemeMode.LIGHT -> false
        ThemeMode.DARK -> true
    }

    val azioneNotifica by NotificationRouter.azioneNotifica.collectAsState()

    var isNavigationCollapsed by remember { mutableStateOf(false) }
    val nestedScrollConnection = remember {
        object : NestedScrollConnection {
            override fun onPreScroll(available: Offset, source: NestedScrollSource): Offset {
                if (available.y < -15f) {
                    isNavigationCollapsed = true
                } else if (available.y > 15f) {
                    isNavigationCollapsed = false
                }
                return Offset.Zero
            }
        }
    }

    MonetixTheme(darkTheme = useDarkTheme) {

        if (azioneNotifica == "resoconto_sera") {
            // 🚀 RICALCOLO LIVE: Ignoriamo i vecchi valori statici e usiamo il database aggiornato e filtrato!
            val todayEpochDays = today.toEpochDays().toLong()
            val movimentiPuliti = transactions.filter { tx ->
                val key = (tx.merchantKey ?: "").lowercase()
                val desc = (tx.description ?: "").lowercase()

                val isCash = tx.id.startsWith("tx_cash_") || tx.accountId?.startsWith("sys_cash_") == true || key.contains("[cash:") || desc.contains("[cash:")

                val isSavings = key.contains("[pb:") || key.contains("[sav:") || key.contains("[goal:") || key.contains("[pac_sav:") ||
                        key.contains("salvadanaio") || key.contains("arrotondamento") || key.contains("pac") ||
                        desc.contains("arrotondamento") || desc.contains("[pb:") || desc.contains("[sav:") || desc.contains("[goal:") || desc.contains("[pac_sav:") ||
                        tx.accountId == "salvadanaio_virtuale" || tx.fromAccountId == "salvadanaio_virtuale" || tx.toAccountId == "salvadanaio_virtuale"

                // IL NOSTRO SCUDO INVINCIBILE
                !tx.isDeleted &&
                        !tx.isHidden &&
                        tx.categoryId != "sys_vaporized" &&
                        tx.dateEpochDay == todayEpochDays &&
                        !isCash &&
                        !isSavings
            }

            // Calcoliamo i nuovi totali puliti
            val entrateCalcolate = movimentiPuliti.filter { it.type == "INCOME" }.sumOf { it.amountCents }
            val usciteCalcolate = movimentiPuliti.filter { it.type == "EXPENSE" }.sumOf { if(it.amountCents < 0) -it.amountCents else it.amountCents }
            val trasferimentiCalcolati = movimentiPuliti.filter { it.type == "TRANSFER" }.sumOf { if(it.amountCents < 0) -it.amountCents else it.amountCents }

            // Prepariamo le stringhe per le UI Card
            val entrate = entrateCalcolate / 100
            val entrateCents = (entrateCalcolate % 100).toString().padStart(2, '0')
            val uscite = usciteCalcolate / 100
            val usciteCents = (usciteCalcolate % 100).toString().padStart(2, '0')
            val trasf = trasferimentiCalcolati / 100
            val trasfCents = (trasferimentiCalcolati % 100).toString().padStart(2, '0')

            AlertDialog(
                onDismissRequest = { NotificationRouter.clearAction() },
                containerColor = MaterialTheme.colorScheme.surface,
                title = { Text("Resoconto di Oggi 🌙", color = MaterialTheme.colorScheme.primary, fontWeight = FontWeight.Black) },
                text = {
                    Column(verticalArrangement = Arrangement.spacedBy(12.dp)) {
                        Text("Ecco il bilancio della tua giornata:", color = MaterialTheme.colorScheme.onSurfaceVariant)

                        Surface(shape = RoundedCornerShape(12.dp), color = Color(0xFF10B981).copy(alpha = 0.1f), modifier = Modifier.fillMaxWidth()) {
                            Row(modifier = Modifier.padding(12.dp), horizontalArrangement = Arrangement.SpaceBetween) {
                                Text("🟢 Entrate", fontWeight = FontWeight.Bold, color = Color(0xFF10B981))
                                Text("+€$entrate,$entrateCents", fontWeight = FontWeight.Bold, color = Color(0xFF10B981))
                            }
                        }
                        Surface(shape = RoundedCornerShape(12.dp), color = MaterialTheme.colorScheme.error.copy(alpha = 0.1f), modifier = Modifier.fillMaxWidth()) {
                            Row(modifier = Modifier.padding(12.dp), horizontalArrangement = Arrangement.SpaceBetween) {
                                Text("🔴 Uscite", fontWeight = FontWeight.Bold, color = MaterialTheme.colorScheme.error)
                                Text("-€$uscite,$usciteCents", fontWeight = FontWeight.Bold, color = MaterialTheme.colorScheme.error)
                            }
                        }
                        if (NotificationRouter.trasferimentiCents > 0L) {
                            Surface(shape = RoundedCornerShape(12.dp), color = MaterialTheme.colorScheme.primary.copy(alpha = 0.1f), modifier = Modifier.fillMaxWidth()) {
                                Row(modifier = Modifier.padding(12.dp), horizontalArrangement = Arrangement.SpaceBetween) {
                                    Text("🔄 Trasf.", fontWeight = FontWeight.Bold, color = MaterialTheme.colorScheme.primary)
                                    Text("€$trasf,$trasfCents", fontWeight = FontWeight.Bold, color = MaterialTheme.colorScheme.primary)
                                }
                            }
                        }

                        if(NotificationRouter.scadenzeOggi > 0) {
                            Spacer(Modifier.height(4.dp))
                            Text("⚠️ Promemoria: Avevi ${NotificationRouter.scadenzeOggi} scadenze in programma oggi. Ricordati di segnarle!", color = Color(0xFFF59E0B), style = MaterialTheme.typography.labelMedium)
                        }
                    }
                },
                confirmButton = {
                    Button(
                        onClick = { NotificationRouter.clearAction() },
                        colors = ButtonDefaults.buttonColors(containerColor = MaterialTheme.colorScheme.primary, contentColor = MaterialTheme.colorScheme.onPrimary)
                    ) { Text("OK", fontWeight = FontWeight.Bold) }
                },
                dismissButton = {
                    TextButton(onClick = {
                        NotificationRouter.clearAction()
                        showDailySummaryDetails = true
                    }) { Text("VEDI DETTAGLI", color = MaterialTheme.colorScheme.primary, fontWeight = FontWeight.Bold) }
                }
            )
        }

        if (showDailySummaryDetails) {
            val todayEpochDays = today.toEpochDays().toLong()
            val todayTxs = transactions.filter { tx ->
                val key = (tx.merchantKey ?: "").lowercase()
                val desc = (tx.description ?: "").lowercase()

                // 1. Identifica i contanti
                val isCash = tx.id.startsWith("tx_cash_") || tx.accountId?.startsWith("sys_cash_") == true || key.contains("[cash:") || desc.contains("[cash:")

                // 🚀 2. Identifica TUTTI i movimenti virtuali dei salvadanai, sogni e PAC
                val isSavings = key.contains("[pb:") || key.contains("[sav:") || key.contains("[goal:") || key.contains("[pac_sav:") ||
                        key.contains("salvadanaio") || key.contains("arrotondamento") || key.contains("pac") ||
                        desc.contains("arrotondamento") || desc.contains("[pb:") || desc.contains("[sav:") || desc.contains("[goal:") || desc.contains("[pac_sav:") ||
                        tx.accountId == "salvadanaio_virtuale" || tx.fromAccountId == "salvadanaio_virtuale" || tx.toAccountId == "salvadanaio_virtuale"

                // 🚀 IL FILTRO DEFINITIVO E BLINDATO:
                !tx.isDeleted &&                     // Esclude le operazioni cancellate
                        !tx.isHidden &&                      // Esclude i movimenti nascosti dall'utente
                        tx.categoryId != "sys_vaporized" &&  // Esclude i conguagli vaporizzati
                        tx.dateEpochDay == todayEpochDays && // Prende solo i movimenti di oggi
                        !isCash &&                           // Esclude i "di cui" in contanti
                        !isSavings                           // 🚀 NOVITÀ: Esclude arrotondamenti e salvadanai
            }.sortedByDescending { it.createdAtEpochMs }

            AlertDialog(
                onDismissRequest = { showDailySummaryDetails = false },
                containerColor = MaterialTheme.colorScheme.surface,
                title = { Text("Movimenti di Oggi 🧾", color = MaterialTheme.colorScheme.onSurface, fontWeight = FontWeight.Black) },
                text = {
                    if (todayTxs.isEmpty()) {
                        Text("Nessun movimento registrato oggi.", color = MaterialTheme.colorScheme.onSurfaceVariant)
                    } else {
                        Column(
                            verticalArrangement = Arrangement.spacedBy(8.dp),
                            modifier = Modifier.heightIn(max = 400.dp).verticalScroll(rememberScrollState())
                        ) {
                            todayTxs.forEach { tx ->
                                val isIncome = tx.type == "INCOME"
                                val isTransfer = tx.type == "TRANSFER"
                                val amountColor = if (isIncome) Color(0xFF10B981) else if (isTransfer) MaterialTheme.colorScheme.onSurface else MaterialTheme.colorScheme.error
                                val sign = if (isIncome) "+" else if (isTransfer) "" else "-"

                                Row(
                                    modifier = Modifier.fillMaxWidth().background(MaterialTheme.colorScheme.surfaceVariant.copy(alpha=0.5f), RoundedCornerShape(8.dp)).padding(12.dp),
                                    verticalAlignment = Alignment.CenterVertically
                                ) {
                                    Text(tx.logoEmoji?.takeIf { it.isNotBlank() } ?: if(isIncome) "💵" else if(isTransfer) "🔄" else "💸", fontSize = 24.sp)
                                    Spacer(Modifier.width(12.dp))
                                    Column(modifier = Modifier.weight(1f)) {

                                        // 🚀 FIX: Controlliamo sia il merchantKey che la description e peschiamo il nome reale!
                                        val cleanMerchant = tx.merchantKey?.replace(Regex("\\[.*?\\]"), "")?.trim()
                                        val cleanDesc = tx.description?.replace(Regex("\\[.*?\\]"), "")?.trim()

                                        var finalName = cleanMerchant?.takeIf { it.isNotBlank() } ?: cleanDesc?.takeIf { it.isNotBlank() }

                                        // 🚀 Fallback d'emergenza: se il nome manca nei testi, lo peschiamo dall'archivio usando il tag ID
                                        if (finalName == null) {
                                            val sysText = tx.merchantKey ?: tx.description ?: ""
                                            val recMatch = Regex("\\[rec:([^\\]]+)\\]").find(sysText)
                                            val finMatch = Regex("\\[fin:([^\\]]+)\\]").find(sysText)
                                            if (recMatch != null) {
                                                finalName = recurringItems.find { it.id == recMatch.groupValues[1] }?.name?.trim()
                                            } else if (finMatch != null) {
                                                finalName = financings.find { it.id == finMatch.groupValues[1] }?.name?.trim()
                                            }
                                        }

                                        val displayTesto = finalName?.takeIf { it.isNotBlank() } ?: "Operazione"

                                        Text(displayTesto, fontWeight = FontWeight.Bold, maxLines = 1, overflow = TextOverflow.Ellipsis, color = MaterialTheme.colorScheme.onSurface)
                                        Text(tx.subcategoryText ?: "Altro", style = MaterialTheme.typography.labelSmall, color = MaterialTheme.colorScheme.onSurfaceVariant)
                                    }
                                    Text("$sign${formatEuroFromCents(tx.amountCents, false)}", fontWeight = FontWeight.Black, color = amountColor)
                                }
                            }
                        }
                    }
                },
                confirmButton = {
                    Button(onClick = { showDailySummaryDetails = false }) { Text("CHIUDI") }
                }
            )
        } else if (azioneNotifica == "scadenze_mattina") {
            val domani = today.plus(DatePeriod(days = 1))
            val giornoDomani = domani.dayOfMonth

            val msScadenzaDomani = domani.toEpochDays().toLong() * 86400000L

            val ricorrentiDomani = recurringItems.filter { !it.isDeleted && it.isEnabled && it.dayOfMonth.toInt() == giornoDomani }

            // 🚀 FIX: FILTRO NOTIFICHE MATTUTINE (LEGGE IL NUOVO DAY!)
            val debitiDomani = financings.filter { fin ->
                val startDay = try { LocalDate.fromEpochDays(fin.startEpochDay.toInt()).dayOfMonth } catch(e: Exception) { 1 }
                val match = Regex("\\[DAY:(\\d+)\\]").find(fin.purpose ?: "")
                val targetDay = match?.groupValues?.get(1)?.toIntOrNull() ?: startDay

                !fin.isDeleted && !fin.isClosed && targetDay == giornoDomani
            }

            val pagatiAlVolo = remember { mutableStateListOf<String>() }

            AlertDialog(
                onDismissRequest = { NotificationRouter.clearAction() },
                containerColor = MaterialTheme.colorScheme.surface,
                title = { Text("Scadenze di Domani 🚨", color = Color(0xFFF59E0B), fontWeight = FontWeight.Bold) },
                text = {
                    if (ricorrentiDomani.isEmpty() && debitiDomani.isEmpty()) {
                        Text("Nessuna scadenza o rata rilevata per domani. Tutto tranquillo!", color = MaterialTheme.colorScheme.onSurface)
                    } else {
                        Column(
                            verticalArrangement = Arrangement.spacedBy(12.dp),
                            modifier = Modifier.verticalScroll(rememberScrollState())
                        ) {
                            Text("Ecco cosa c'è in programma. Salda tutto subito da qui:", style = MaterialTheme.typography.bodyMedium, color = MaterialTheme.colorScheme.onSurfaceVariant)

                            ricorrentiDomani.forEach { rec ->
                                val isPagato = pagatiAlVolo.contains(rec.id)
                                Row(
                                    modifier = Modifier.fillMaxWidth().background(MaterialTheme.colorScheme.surfaceVariant, RoundedCornerShape(8.dp)).padding(12.dp),
                                    verticalAlignment = Alignment.CenterVertically, horizontalArrangement = Arrangement.SpaceBetween
                                ) {
                                    Column(modifier = Modifier.weight(1f)) {
                                        Text(rec.name ?: "Spesa Fissa", fontWeight = FontWeight.Bold, maxLines = 1, overflow = TextOverflow.Ellipsis, color = MaterialTheme.colorScheme.onSurface)
                                        Text("€${rec.amountCents / 100},${(rec.amountCents % 100).toString().padStart(2, '0')}", style = MaterialTheme.typography.bodySmall, color = MaterialTheme.colorScheme.onSurfaceVariant)
                                    }

                                    if (isPagato) {
                                        Icon(Icons.Rounded.CheckCircle, contentDescription = "Pagato", tint = Color(0xFF10B981))
                                    } else {
                                        Button(
                                            onClick = {
                                                val activeId = activeAccountId ?: accounts.firstOrNull { !it.isDeleted }?.id ?: ""
                                                if (activeId.isNotBlank()) {
                                                    val nowMs = Clock.System.now().toEpochMilliseconds()
                                                    val isTransfer = rec.toAccountId != null
                                                    val mesiItaliani = listOf("Gennaio", "Febbraio", "Marzo", "Aprile", "Maggio", "Giugno", "Luglio", "Agosto", "Settembre", "Ottobre", "Novembre", "Dicembre")
                                                    val meseStr = mesiItaliani.getOrNull(domani.monthNumber - 1) ?: ""
                                                    val baseNote = rec.notes?.takeIf { it.isNotBlank() }?.trim() ?: rec.name?.trim() ?: "Spesa Fissa"
                                                    val cleanMerchant = rec.name?.trim() ?: "Spesa"

                                                    val newTx = TransactionEntity(
                                                        id = "tx_rec_early_${nowMs}_${kotlin.random.Random.nextInt(1000)}", accountId = rec.accountId ?: activeId, toAccountId = rec.toAccountId, fromAccountId = if (isTransfer) rec.accountId else null, amountCents = rec.amountCents, type = if (isTransfer) "TRANSFER" else "EXPENSE",
                                                        dateEpochDay = today.toEpochDays().toLong(), // 🚀 FORZATO A OGGI
                                                        categoryId = rec.categoryId ?: "",
                                                        description = "$baseNote $meseStr [rec:${rec.id}] [manual]", // 🚀 AGGIUNTO [manual]
                                                        merchantKey = cleanMerchant, subcategoryText = if (isTransfer) "Giroconto" else "Spesa Fissa", logoEmoji = rec.logoEmoji, logoUri = rec.logoUri, isHidden = false, isDeleted = false, reminderDays = -1L, createdAtEpochMs = nowMs, updatedAtEpochMs = nowMs
                                                    )
                                                    homeViewModel.saveTransaction(newTx)
                                                    homeViewModel.saveRecurring(rec.copy(updatedAtEpochMs = msScadenzaDomani))
                                                    pagatiAlVolo.add(rec.id)
                                                }
                                            },
                                            colors = ButtonDefaults.buttonColors(containerColor = MaterialTheme.colorScheme.primary, contentColor = MaterialTheme.colorScheme.onPrimary),
                                            contentPadding = PaddingValues(horizontal = 12.dp, vertical = 4.dp), modifier = Modifier.height(32.dp)
                                        ) { Text("PAGA", fontSize = 12.sp, fontWeight = FontWeight.Bold) }
                                    }
                                }
                            }

                            debitiDomani.forEach { fin ->
                                val isPagato = pagatiAlVolo.contains(fin.id)
                                val totalInstallment = fin.installmentAmountCents + (fin.commissionCents ?: 0L)

                                Row(
                                    modifier = Modifier.fillMaxWidth().background(MaterialTheme.colorScheme.surfaceVariant, RoundedCornerShape(8.dp)).padding(12.dp),
                                    verticalAlignment = Alignment.CenterVertically, horizontalArrangement = Arrangement.SpaceBetween
                                ) {
                                    Column(modifier = Modifier.weight(1f)) {
                                        Text(fin.name ?: "Rata", fontWeight = FontWeight.Bold, maxLines = 1, overflow = TextOverflow.Ellipsis, color = MaterialTheme.colorScheme.onSurface)
                                        Text("€${totalInstallment / 100},${(totalInstallment % 100).toString().padStart(2, '0')} (Rata)", style = MaterialTheme.typography.bodySmall, color = MaterialTheme.colorScheme.onSurfaceVariant)
                                    }

                                    if (isPagato) {
                                        Icon(Icons.Rounded.CheckCircle, contentDescription = "Pagato", tint = Color(0xFF10B981))
                                    } else {
                                        Button(
                                            onClick = {
                                                val activeId = activeAccountId ?: accounts.firstOrNull { !it.isDeleted }?.id ?: ""
                                                if (activeId.isNotBlank()) {
                                                    val nowMs = Clock.System.now().toEpochMilliseconds()
                                                    val mesiItaliani = listOf("Gennaio", "Febbraio", "Marzo", "Aprile", "Maggio", "Giugno", "Luglio", "Agosto", "Settembre", "Ottobre", "Novembre", "Dicembre")
                                                    val meseStr = mesiItaliani.getOrNull(domani.monthNumber - 1) ?: ""

                                                    // Rimuoviamo il tag per la dicitura pulita della spesa
                                                    val cleanPurpose = fin.purpose?.replace(Regex("\\[DAY:\\d+\\]"), "")?.trim()
                                                    val baseNote = cleanPurpose?.takeIf { it.isNotBlank() } ?: fin.name?.trim() ?: "Rata Finanziamento"
                                                    val cleanCreditor = (fin.creditorName ?: fin.name)?.trim() ?: "Rata"

                                                    val newTx = TransactionEntity(
                                                        id = "tx_fin_early_${nowMs}_${kotlin.random.Random.nextInt(1000)}", accountId = fin.accountId ?: activeId, toAccountId = null, fromAccountId = null, amountCents = totalInstallment, type = "EXPENSE",
                                                        dateEpochDay = today.toEpochDays().toLong(), // 🚀 FORZATO A OGGI
                                                        categoryId = fin.categoryId ?: "",
                                                        description = "$baseNote $meseStr [fin:${fin.id}] [manual]", // 🚀 AGGIUNTO [manual]
                                                        merchantKey = cleanCreditor, subcategoryText = "Rata Debito", logoEmoji = fin.logoEmoji, logoUri = fin.logoUri, isHidden = false, isDeleted = false, reminderDays = -1L, createdAtEpochMs = nowMs, updatedAtEpochMs = nowMs
                                                    )
                                                    homeViewModel.saveTransaction(newTx)
                                                    val nuovoResiduo = (fin.remainingAmountCents - fin.installmentAmountCents).coerceAtLeast(0L)
                                                    homeViewModel.saveFinancing(fin.copy(remainingAmountCents = nuovoResiduo, updatedAtEpochMs = msScadenzaDomani))
                                                    pagatiAlVolo.add(fin.id)
                                                }
                                            },
                                            colors = ButtonDefaults.buttonColors(containerColor = Color(0xFFD97706)),
                                            contentPadding = PaddingValues(horizontal = 12.dp, vertical = 4.dp), modifier = Modifier.height(32.dp)
                                        ) { Text("PAGA RATA", fontSize = 12.sp, fontWeight = FontWeight.Bold, color = Color.White) }
                                    }
                                }
                            }
                        }
                    }
                },
                confirmButton = {
                    TextButton(onClick = { NotificationRouter.clearAction() }) { Text("FATTO", color = MaterialTheme.colorScheme.primary, fontWeight = FontWeight.Bold) }
                }
            )
        }

        var globalSearchQuery by remember { mutableStateOf("") }
        var targetTxId by remember { mutableStateOf<String?>(null) }

        val spentByCategoryMap = remember(transactions) {
            val todayDate = Clock.System.todayIn(TimeZone.currentSystemDefault())
            val currentMonthTxs = transactions.filter { tx ->
                val txDate = Instant.fromEpochMilliseconds(tx.createdAtEpochMs).toLocalDateTime(TimeZone.currentSystemDefault())
                tx.type == "EXPENSE" && !tx.isDeleted && txDate.month == todayDate.month && txDate.year == todayDate.year
            }
            currentMonthTxs.groupBy { it.categoryId ?: "ALTRO" }.mapValues { (_, txs) -> txs.sumOf { it.amountCents } }
        }

        var showAddTxDialog by remember { mutableStateOf(false) }
        var initialTxType by remember { mutableStateOf("EXPENSE") }

        var capturedBankData by remember { mutableStateOf<BankNotificationData?>(null) }

        LaunchedEffect(initialBankData) {
            if (initialBankData != null) {
                initialTxType = if (initialBankData.isIncome) "INCOME" else "EXPENSE"
                showAddTxDialog = true
            }
        }

        LaunchedEffect(shortcutAction, shortcutTriggerTime) {
            if (shortcutAction != null && shortcutTriggerTime > 0L) {
                initialTxType = shortcutAction
                showAddTxDialog = true
            }
        }

        var showEditTxDialog by remember { mutableStateOf(false) }
        var transactionToEdit by remember { mutableStateOf<TransactionEntity?>(null) }

        var showAccountDialog by remember { mutableStateOf(false) }
        var accountToEdit by remember { mutableStateOf<AccountEntity?>(null) }

        var showRecurringDialog by remember { mutableStateOf(false) }
        var recurringToEdit by remember { mutableStateOf<RecurringExpenseEntity?>(null) }

        var showBudgetDialog by remember { mutableStateOf(false) }
        var budgetToEdit by remember { mutableStateOf<BudgetEntity?>(null) }

        var showSavingsGoalDialog by remember { mutableStateOf(false) }
        var savingsGoalToEdit by remember { mutableStateOf<SavingsGoalEntity?>(null) }

        LaunchedEffect(screen) {
            val targetPage = screen.ordinal
            if (pagerState.currentPage != targetPage) {
                pagerState.animateScrollToPage(targetPage)
            }
        }
        LaunchedEffect(pagerState.currentPage) {
            screen = Screen.entries[pagerState.currentPage]
        }

        LaunchedEffect(Unit) {
            homeViewModel.runStartupTasks(database, homeViewModel.firestore)
        }

        LaunchedEffect(firebaseUser) {
            if (firebaseUser != null) {
                // 🚀 FIX PER IL WEB: Diamo il tempo al Token di sicurezza di validarsi sul server.
                // Se chiediamo i dati all'istante, Firebase ci sbatte la porta in faccia e blocca il download.
                delay(600)
                homeViewModel.impostaUtente(firebaseUser!!.uid)
                homeViewModel.sincronizzaTutto()
            }
        }

        var hiddenAccountIds by remember { mutableStateOf(setOf<String>()) }
        val activeAccount = accounts.find { it.id == activeAccountId }
        var homeCardBalanceCents by remember { mutableStateOf(0L) }
        val activeAccountName = activeAccount?.name ?: "Tutti i conti"
        val currentBalance = activeAccount?.let { accountingBalancesMap[it.id] } ?: globalBalanceCents

        val cloudBackgroundUri by homeViewModel.firestore.scaricaAppBackgroundUri().collectAsState(initial = null)
        val localBackgroundUri = remember { mutableStateOf(settings.getStringOrNull("app_background_uri")) }
        val appBackgroundUri = localBackgroundUri.value ?: cloudBackgroundUri ?: userPrefs?.appBackgroundUri?.takeIf { it.isNotBlank() }

        val imageModel = remember(appBackgroundUri) {
            if (appBackgroundUri != null && appBackgroundUri.startsWith("data:image")) {
                try {
                    val base64String = appBackgroundUri.substringAfter("base64,")
                    Base64.Default.decode(base64String)
                } catch (e: Exception) {
                    appBackgroundUri
                }
            } else {
                appBackgroundUri
            }
        }

        var isScreenPopupOpen by remember { mutableStateOf(false) }

        val isAnyPopupOrOverlayOpen = isScreenPopupOpen ||
                showAddTxDialog || showEditTxDialog || showAccountDialog ||
                showRecurringDialog || showBudgetDialog || showSavingsGoalDialog ||
                showSettingsDialog || showDailySummaryDetails || showSweepPrompt != null ||
                (showGlobalCalculator && !isCalculatorMinimized) || showNukePrompt || showGlobalNotifications || showTrashScreen

        if (appLockEnabled && !isAppUnlocked) {
            // 🔒 SCHERMATA DI BLOCCO SOLIDA ED OPACA (Nessun dato o cifra dell'app viene renderizzato sotto!)
            Box(
                modifier = Modifier
                    .fillMaxSize()
                    .background(Color(0xFF0F172A))
                    .systemBarsPadding(),
                contentAlignment = Alignment.Center
            ) {
                Surface(
                    modifier = Modifier.padding(24.dp).fillMaxWidth().widthIn(max = 400.dp),
                    shape = RoundedCornerShape(32.dp),
                    color = Color.White.copy(alpha = 0.12f),
                    border = BorderStroke(1.5.dp, Color.White.copy(alpha = 0.25f))
                ) {
                    Column(
                        modifier = Modifier.padding(32.dp),
                        horizontalAlignment = Alignment.CenterHorizontally
                    ) {
                        Surface(
                            shape = CircleShape,
                            color = Color(0xFF60A5FA).copy(alpha = 0.2f),
                            modifier = Modifier.size(72.dp)
                        ) {
                            Icon(
                                Icons.Rounded.Fingerprint,
                                contentDescription = "Protezione Biometrica",
                                tint = Color(0xFF60A5FA),
                                modifier = Modifier.size(40.dp).wrapContentSize(Alignment.Center)
                            )
                        }
                        Spacer(Modifier.height(20.dp))
                        Text(
                            "Monetix è Bloccato",
                            style = MaterialTheme.typography.titleLarge.copy(fontWeight = FontWeight.Bold),
                            color = Color.White
                        )
                        Spacer(Modifier.height(8.dp))
                        Text(
                            "Autenticati con l'impronta o il volto per accedere ai tuoi dati finanziari.",
                            style = MaterialTheme.typography.bodyMedium,
                            color = Color(0xFFA0A0A0),
                            textAlign = TextAlign.Center
                        )
                        Spacer(Modifier.height(28.dp))
                        Button(
                            onClick = {
                                triggerHapticTick()
                                val bio = biometricAuth
                                if (bio != null && bio.isAvailable()) {
                                    bio.authenticate(
                                        title = "Sblocco Monetix",
                                        subtitle = "Usa la biometria per sbloccare l'app",
                                        onSuccess = { isAppUnlocked = true },
                                        onError = { err -> println("Errore sblocco: $err") }
                                    )
                                } else {
                                    isAppUnlocked = true
                                }
                            },
                            modifier = Modifier.fillMaxWidth().height(52.dp),
                            shape = RoundedCornerShape(16.dp),
                            colors = ButtonDefaults.buttonColors(containerColor = Color(0xFF60A5FA), contentColor = Color.White)
                        ) {
                            Icon(Icons.Rounded.Fingerprint, null, modifier = Modifier.size(20.dp))
                            Spacer(Modifier.width(8.dp))
                            Text("SBLOCCA ORA", fontWeight = FontWeight.Bold)
                        }
                    }
                }
            }
        } else if (!isSyncComplete) {
            val infiniteTransition = rememberInfiniteTransition(label = "splashPulse")
            val logoScale by infiniteTransition.animateFloat(
                initialValue = 0.92f,
                targetValue = 1.08f,
                animationSpec = infiniteRepeatable(
                    animation = tween(900, easing = FastOutSlowInEasing),
                    repeatMode = RepeatMode.Reverse
                ),
                label = "logoScale"
            )
            val logoAlpha by infiniteTransition.animateFloat(
                initialValue = 0.70f,
                targetValue = 1.0f,
                animationSpec = infiniteRepeatable(
                    animation = tween(900, easing = FastOutSlowInEasing),
                    repeatMode = RepeatMode.Reverse
                ),
                label = "logoAlpha"
            )

            MonetixTheme {
                Surface(modifier = Modifier.fillMaxSize(), color = Color(0xFF0F172A)) {
                    Box(contentAlignment = Alignment.Center, modifier = Modifier.fillMaxSize()) {
                        Column(
                            horizontalAlignment = Alignment.CenterHorizontally,
                            verticalArrangement = Arrangement.Center,
                            modifier = Modifier.padding(32.dp)
                        ) {
                            Surface(
                                modifier = Modifier
                                    .size(88.dp)
                                    .graphicsLayer {
                                        scaleX = logoScale
                                        scaleY = logoScale
                                        alpha = logoAlpha
                                    },
                                shape = CircleShape,
                                color = Color(0xFF10B981).copy(alpha = 0.20f),
                                border = BorderStroke(1.5.dp, Color(0xFF10B981).copy(alpha = 0.5f))
                            ) {
                                Box(contentAlignment = Alignment.Center) {
                                    Text("💰", fontSize = 42.sp)
                                }
                            }

                            Spacer(Modifier.height(28.dp))

                            Text(
                                "MONETIX",
                                style = MaterialTheme.typography.titleLarge.copy(
                                    fontWeight = FontWeight.Black,
                                    letterSpacing = 3.sp
                                ),
                                color = Color.White
                            )

                            Spacer(Modifier.height(20.dp))

                            LinearProgressIndicator(
                                modifier = Modifier
                                    .width(160.dp)
                                    .height(4.dp)
                                    .clip(RoundedCornerShape(50)),
                                color = Color(0xFF10B981),
                                trackColor = Color.White.copy(alpha = 0.15f)
                            )

                            Spacer(Modifier.height(12.dp))

                            Text(
                                "Sincronizzazione in corso...",
                                style = MaterialTheme.typography.labelSmall,
                                color = Color(0xFFA0A0A0)
                            )
                        }
                    }
                }
            }
        } else {
            CompositionLocalProvider(LocalHasCustomBackground provides (imageModel != null)) {
                Box(modifier = Modifier.fillMaxSize().background(MaterialTheme.colorScheme.background)) {
                    if (imageModel != null) {
                        coil3.compose.AsyncImage(
                            model = imageModel,
                        contentDescription = "Sfondo personalizzato",
                        contentScale = androidx.compose.ui.layout.ContentScale.Crop,
                        modifier = Modifier.fillMaxSize()
                    )
                    // Layer oscurante (Dimming) per garantire il contrasto col testo bianco di Monetix
                    Box(modifier = Modifier.fillMaxSize().background(Color.Black.copy(alpha = 0.55f)))
                }

                Scaffold(
                    containerColor = Color.Transparent,
                    snackbarHost = { SnackbarHost(hostState = snackbarHostState, modifier = Modifier.padding(bottom = 120.dp)) },
            bottomBar = {
                AnimatedVisibility(
                    visible = !isAnyPopupOrOverlayOpen,
                    enter = slideInVertically(initialOffsetY = { it }) + fadeIn(),
                    exit = slideOutVertically(targetOffsetY = { it }) + fadeOut()
                ) {
                    val haptic = LocalHapticFeedback.current

                    var draggedItem by remember { mutableStateOf<Screen?>(null) }
                    var dragOffsetX by remember { mutableStateOf(0f) }

                    val barHeight = if (isNavigationCollapsed) 52.dp else 64.dp

                    Box(
                        modifier = Modifier
                            .fillMaxWidth()
                            .navigationBarsPadding()
                            .padding(start = 12.dp, end = 12.dp, bottom = 10.dp),
                        contentAlignment = Alignment.BottomCenter
                    ) {
                    BoxWithConstraints(
                        modifier = Modifier
                            .fillMaxWidth()
                            .height(barHeight)
                            .shadow(elevation = if (appBackgroundUri != null) 0.dp else 12.dp, shape = RoundedCornerShape(32.dp))
                            .background(
                                if (appBackgroundUri != null) Color.Black.copy(alpha = 0.45f) else Color(0xFF131138),
                                RoundedCornerShape(32.dp)
                            )
                            .border(
                                1.dp,
                                if (appBackgroundUri != null) Color.White.copy(alpha = 0.20f) else Color.White.copy(alpha = 0.12f),
                                RoundedCornerShape(32.dp)
                            )
                    ) {
                        val itemWidth = maxWidth / navItems.size
                        val itemWidthPx = constraints.maxWidth.toFloat() / navItems.size

                        val selectedIndex = navItems.indexOfFirst { it.second == screen }.coerceAtLeast(0)

                        var dragX by remember { mutableStateOf<Float?>(null) }
                        val targetPx = dragX ?: (itemWidthPx * selectedIndex)

                        val animatedPx by animateFloatAsState(
                            targetValue = targetPx,
                            animationSpec = spring(dampingRatio = 0.8f, stiffness = Spring.StiffnessMedium),
                            label = "selectorX"
                        )
                        val selectorOffset = with(LocalDensity.current) { animatedPx.toDp() }

                        // 🚀 CAPSULA ATTIVA STILE REVOLUT (Sfondo arrotondato attorno all'item attivo)
                        Box(
                            modifier = Modifier
                                .align(Alignment.CenterStart)
                                .offset(x = selectorOffset)
                                .width(itemWidth)
                                .fillMaxHeight()
                                .padding(4.dp)
                                .background(Color.White.copy(alpha = 0.18f), RoundedCornerShape(26.dp))
                                .border(1.dp, Color.White.copy(alpha = 0.22f), RoundedCornerShape(26.dp))
                                .zIndex(1f)
                        )

                        val handleDragEndOrCancel = {
                            val orderString = navItems.joinToString(",") { it.second.name }
                            scope.launch {
                                try { database.settingsQueries.insertSetting("nav_order", orderString) } catch (e: Exception) {}
                                homeViewModel.firestore.salvaOrdineNavigazione(orderString)
                            }
                        }

                        Row(
                            modifier = Modifier
                                .fillMaxWidth()
                                .fillMaxHeight()
                                .align(Alignment.CenterStart)
                                .pointerInput(draggedItem) {
                                    if (draggedItem == null) {
                                        detectHorizontalDragGestures(
                                            onDragStart = { offset -> dragX = offset.x },
                                            onDragEnd = {
                                                dragX?.let { x ->
                                                    val newIndex = (x / itemWidthPx).roundToInt().coerceIn(0, navItems.size - 1)
                                                    screen = navItems[newIndex].second
                                                }
                                                dragX = null
                                            },
                                            onDragCancel = { dragX = null },
                                            onHorizontalDrag = { change, dragAmount ->
                                                change.consume()
                                                dragX = ((dragX ?: 0f) + dragAmount).coerceIn(0f, constraints.maxWidth.toFloat() - itemWidthPx)

                                                val liveIndex = ((dragX!! + (itemWidthPx / 2)) / itemWidthPx).toInt().coerceIn(0, navItems.size - 1)
                                                if (screen != navItems[liveIndex].second) {
                                                    screen = navItems[liveIndex].second
                                                }
                                            }
                                        )
                                    }
                                },
                            horizontalArrangement = Arrangement.SpaceBetween,
                            verticalAlignment = Alignment.CenterVertically
                        ) {
                            navItems.forEach { pair ->
                                val itemScreen = pair.second
                                val isDragged = draggedItem == itemScreen
                                val isSelected = screen == itemScreen

                                key(itemScreen) {
                                    Box(
                                        modifier = Modifier
                                            .width(itemWidth)
                                            .fillMaxHeight()
                                            .zIndex(if (isDragged || isSelected) 10f else 2f)
                                            .offset { IntOffset(x = if (isDragged) dragOffsetX.roundToInt() else 0, y = 0) }
                                            .pointerInput(itemScreen) {
                                                detectDragGesturesAfterLongPress(
                                                    onDragStart = {
                                                        draggedItem = itemScreen
                                                        haptic.performHapticFeedback(HapticFeedbackType.LongPress)
                                                    },
                                                    onDrag = { change, dragAmount ->
                                                        change.consume()
                                                        dragOffsetX += dragAmount.x

                                                        val currentIndex = navItems.indexOfFirst { it.second == itemScreen }
                                                        val dragSteps = (dragOffsetX / itemWidthPx).roundToInt()

                                                        if (dragSteps != 0) {
                                                            val targetIndex = (currentIndex + dragSteps).coerceIn(0, navItems.size - 1)

                                                            if (targetIndex != currentIndex) {
                                                                val newList = navItems.toMutableList()
                                                                val element = newList.removeAt(currentIndex)
                                                                newList.add(targetIndex, element)
                                                                navItems = newList

                                                                dragOffsetX -= (targetIndex - currentIndex) * itemWidthPx
                                                                haptic.performHapticFeedback(HapticFeedbackType.TextHandleMove)
                                                            }
                                                        }
                                                    },
                                                    onDragEnd = {
                                                        draggedItem = null
                                                        dragOffsetX = 0f
                                                        handleDragEndOrCancel()
                                                    },
                                                    onDragCancel = {
                                                        draggedItem = null
                                                        dragOffsetX = 0f
                                                        handleDragEndOrCancel()
                                                    }
                                                )
                                            },
                                        contentAlignment = Alignment.Center
                                    ) {
                                        IconItem(pair, screen, isNavigationCollapsed, { screen = itemScreen })
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
        ) { paddingValues ->
            // 🚀 CREIAMO UNA COLONNA: PRIMA L'HEADER, POI LE SCHERMATE
            Column(
                modifier = Modifier
                    .fillMaxSize()
                    .nestedScroll(nestedScrollConnection)
                // 🚀 FIX: Padding rimosso! Ora l'app fluisce liberamente sotto la barra in vetro!
            ) {
                // 🚀 1. L'HEADER GLOBALE (Nascosto su tutte le schermate full-screen)
                if (screen != Screen.HOME && screen != Screen.FINANCINGS && screen != Screen.DEBTS && screen != Screen.STATS && screen != Screen.SAVINGS && screen != Screen.TRANSACTIONS && screen != Screen.RECURRING) {
                    Surface(
                        color = if (appBackgroundUri != null) Color.Transparent else MaterialTheme.colorScheme.background,
                        modifier = Modifier.fillMaxWidth()
                    ) {
                        Box(modifier = Modifier.statusBarsPadding()) {
                            MonetixHeader(
                                isHomeScreen = false,
                                title = when(screen) {
                                    Screen.FINANCINGS -> "I tuoi debiti"
                                    Screen.STATS -> "Statistiche"
                                    Screen.SAVINGS -> "Risparmi"
                                    Screen.RECURRING -> "Ricorrenti"
                                    Screen.TRANSACTIONS -> "Tutti i Movimenti"
                                    else -> ""
                                },
                                userName = userName,
                                greetingText = greetingText,
                                textColor = MaterialTheme.colorScheme.onBackground
                            ) {
                                val iconColor = MaterialTheme.colorScheme.onSurfaceVariant
                                // CAMPANELLA NOTIFICHE GLOBALE
                                IconButton(onClick = { showGlobalNotifications = true }) {
                                    if (hasNotifications) {
                                        BadgedBox(
                                            badge = {
                                                Badge(containerColor = MaterialTheme.colorScheme.error) {
                                                    Text(totalNotifications.toString(), color = Color.White)
                                                }
                                            }
                                        ) {
                                            Icon(Icons.Rounded.Notifications, contentDescription = "Notifiche", tint = iconColor)
                                        }
                                    } else {
                                        Icon(Icons.Rounded.NotificationsNone, contentDescription = "Notifiche", tint = iconColor)
                                    }
                                }

                                // MENU A TENDINA GLOBALE
                                Box {
                                    IconButton(onClick = { topBarMenuExpanded = true }) {
                                        Icon(Icons.Rounded.MoreVert, contentDescription = "Opzioni", tint = iconColor)
                                    }

                                    DropdownMenu(
                                        expanded = topBarMenuExpanded,
                                        onDismissRequest = { topBarMenuExpanded = false },
                                        modifier = Modifier.background(MaterialTheme.colorScheme.surface)
                                    ) {
                                        DropdownMenuItem(text = { Text("Calcolatrice", fontWeight = FontWeight.SemiBold) }, leadingIcon = { Icon(Icons.Rounded.Calculate, null, tint = MaterialTheme.colorScheme.primary) }, onClick = { topBarMenuExpanded = false; showGlobalCalculator = true })
                                        DropdownMenuItem(text = { Text("Sincronizza") }, leadingIcon = { Icon(Icons.Rounded.CloudSync, null, tint = MaterialTheme.colorScheme.onSurfaceVariant) }, onClick = { topBarMenuExpanded = false; homeViewModel.sincronizzaTutto(); scope.launch { snackbarHostState.showSnackbar("Sincronizzazione in corso...", duration = SnackbarDuration.Short) } })
                                        DropdownMenuItem(text = { Text("Cestino") }, leadingIcon = { Icon(Icons.Rounded.DeleteOutline, null, tint = MaterialTheme.colorScheme.onSurfaceVariant) }, onClick = { topBarMenuExpanded = false; showTrashScreen = true })
                                        DropdownMenuItem(text = { Text("Impostazioni") }, leadingIcon = { Icon(Icons.Rounded.Settings, null, tint = MaterialTheme.colorScheme.onSurfaceVariant) }, onClick = { topBarMenuExpanded = false; showSettingsDialog = true })
                                        HorizontalDivider(color = MaterialTheme.colorScheme.outline.copy(alpha = 0.1f))
                                        DropdownMenuItem(text = { Text("Esci", color = MaterialTheme.colorScheme.error) }, leadingIcon = { Icon(Icons.Rounded.Logout, null, tint = MaterialTheme.colorScheme.error) }, onClick = { topBarMenuExpanded = false; scope.launch { Firebase.auth.signOut() } })
                                        DropdownMenuItem(text = { Text("Elimina Tutto", color = MaterialTheme.colorScheme.error) }, leadingIcon = { Icon(Icons.Rounded.DeleteForever, null, tint = MaterialTheme.colorScheme.error) }, onClick = { topBarMenuExpanded = false; showNukePrompt = true })
                                    }
                                }
                            }
                        }
                    }
                }

                // 🚀 2. LE SCHERMATE DELL'APP
                Box(
                    modifier = Modifier.weight(1f)
                ) {
                    val stats = remember(payPeriodStart, payPeriodEnd, transactions, categories, recurringItems, financings, activeAccountId, currentBalance) {
                        StatsEngine.calculateMonthlyStats(
                            startDate = payPeriodStart,
                            endDate = payPeriodEnd,
                            latestTx = transactions,
                            categories = categories,
                            recurringItems = recurringItems,
                            financingItems = financings,
                            activeAccountId = activeAccountId,
                            availableBalanceCents = currentBalance
                        )
                    }

                    val saldoOggi = remember(transactions, activeAccountId, accounts, todayEpochDaysForAlerts) {
                        var sum = 0L
                        val activeAccountIds = accounts.filter { !it.isDeleted }.map { it.id }.toSet()
                        for (tx in transactions) {
                            if (tx.isDeleted || tx.dateEpochDay > todayEpochDaysForAlerts) continue
                            if (activeAccountId == null) {
                                val isMainActive = tx.accountId in activeAccountIds
                                val isFromActive = tx.fromAccountId in activeAccountIds
                                val isToActive = tx.toAccountId in activeAccountIds
                                when (tx.type) {
                                    "INCOME" -> if (isMainActive) sum += tx.amountCents
                                    "EXPENSE" -> if (isMainActive) sum -= tx.amountCents
                                    "TRANSFER" -> {
                                        if (isFromActive && !isToActive) sum -= tx.amountCents
                                        else if (!isFromActive && isToActive) sum += tx.amountCents
                                    }
                                }
                            } else {
                                when (tx.type) {
                                    "INCOME" -> if (tx.accountId == activeAccountId) sum += tx.amountCents
                                    "EXPENSE" -> if (tx.accountId == activeAccountId) sum -= tx.amountCents
                                    "TRANSFER" -> {
                                        if (tx.fromAccountId == activeAccountId) sum -= tx.amountCents
                                        if (tx.toAccountId == activeAccountId) sum += tx.amountCents
                                    }
                                }
                            }
                        }
                        sum
                    }

                    val realAvailableBalance = saldoOggi - stats.unpaidRecurringCents - stats.unpaidFinancingCents

                    val handleSaveTransaction: (TransactionEntity) -> Unit = { tx ->
                        homeViewModel.saveTransaction(tx)

                        // 🚀 FIX: L'arrotondamento parte SOLO se l'importo è MAGGIORE di zero!
                        // Le spese negative (come i prelievi/rimborsi) vengono ignorate in automatico.
                        if (tx.type == "EXPENSE" && tx.amountCents > 0 && !tx.isHidden) {
                            val isSweepTx = tx.description.orEmpty().contains("Arrotondamento", ignoreCase = true) || tx.description.orEmpty().contains("Svuota", ignoreCase = true)
                            val isCashSubTx = tx.id.startsWith("tx_cash_") || tx.accountId?.startsWith("sys_cash_") == true || tx.accountId == "sys_ghost_cash" || tx.description.orEmpty().contains("[cash:", ignoreCase = true)
                            val isFinancingTx = tx.merchantKey?.contains("[fin:", ignoreCase = true) == true || tx.description.orEmpty().contains("[fin:", ignoreCase = true)

                            // 🚀 DOPPIA SICUREZZA: Ignoriamo esplicitamente le transazioni taggate come rimborsi o prelievi
                            val isRefund = tx.subcategoryText == "Rimborso" || tx.description.orEmpty().contains("Prelievo da:", ignoreCase = true)

                            if (autoSweepEnabled && !isSweepTx && !isCashSubTx && !isRefund && !isFinancingTx) {
                                val centesimi = tx.amountCents % 100
                                val daSvuotare = if (centesimi == 0L) 0L else (100L - centesimi)

                                if (daSvuotare > 0L) {
                                    scope.launch {
                                        val nowMs = Clock.System.now().toEpochMilliseconds()
                                        val todayEpoch = tx.dateEpochDay

                                        if (sweepDestination == "SOGNI") {
                                            val target = savingsGoals.firstOrNull { !it.isDeleted && !it.isCompleted }
                                            if (target != null) {
                                                val newTx = TransactionEntity(
                                                    id = "tx_sweep_${nowMs}",
                                                    accountId = tx.accountId ?: activeAccountId ?: accounts.firstOrNull()?.id ?: "",
                                                    toAccountId = target.id,
                                                    fromAccountId = tx.accountId ?: activeAccountId ?: accounts.firstOrNull()?.id ?: "",
                                                    amountCents = daSvuotare,
                                                    type = "TRANSFER",
                                                    dateEpochDay = todayEpoch, categoryId = "",
                                                    description = "Arrotondamento automatico",
                                                    merchantKey = "Sogno: ${target.name} [sav:${target.id}][p:${tx.id}]",
                                                    subcategoryText = "Risparmi", logoEmoji = target.emoji ?: "🎯", logoUri = target.imageUri ?: "",
                                                    isHidden = false, isDeleted = false, reminderDays = null, createdAtEpochMs = nowMs, updatedAtEpochMs = nowMs
                                                )
                                                homeViewModel.saveTransaction(newTx)
                                            }
                                        } else {
                                            val target = piggyBanks.firstOrNull { !it.isDeleted }
                                            if (target != null) {
                                                val newTx = TransactionEntity(
                                                    id = "tx_sweep_${nowMs}",
                                                    accountId = tx.accountId ?: activeAccountId ?: accounts.firstOrNull()?.id ?: "",
                                                    toAccountId = target.id,
                                                    fromAccountId = tx.accountId ?: activeAccountId ?: accounts.firstOrNull()?.id ?: "",
                                                    amountCents = daSvuotare,
                                                    type = "TRANSFER",
                                                    dateEpochDay = todayEpoch, categoryId = "",
                                                    description = "Arrotondamento automatico",
                                                    merchantKey = "Salvadanaio: ${target.name} [pb:${target.id}][p:${tx.id}]",
                                                    subcategoryText = "Risparmi", logoEmoji = target.emoji.takeIf { it.isNotBlank() } ?: "🪙", logoUri = target.imageUri ?: "",
                                                    isHidden = false, isDeleted = false, reminderDays = null, createdAtEpochMs = nowMs, updatedAtEpochMs = nowMs
                                                )
                                                homeViewModel.saveTransaction(newTx)
                                                homeViewModel.savePiggyBank(target.copy(accumulatedCents = target.accumulatedCents + daSvuotare, updatedAtEpochMs = nowMs))
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }

                    Crossfade(targetState = screen) { currentScreen ->
                        when (currentScreen) {
                            Screen.DEBTS -> {
                                DebtManagerScreen(
                                    accounts = accounts,
                                    transactions = transactions,
                                    onBack = { screen = Screen.HOME },
                                    onSaveTransaction = { tx -> handleSaveTransaction(tx) },
                                    onDeleteTransaction = { tx -> homeViewModel.saveTransaction(tx.copy(isDeleted = true)) },
                                    onPopupStateChanged = { isScreenPopupOpen = it }
                                )
                            }
                            Screen.HOME -> {
                                HomeScreen(
                                    safetyBufferCents = safetyBufferCents,
                                    onUpdateSafetyBuffer = { newValue ->
                                        safetyBufferCents = newValue
                                        pendingCloudSave = true
                                        scope.launch(Dispatchers.Default) {
                                            try {
                                                database.settingsQueries.insertSetting("safety_buffer", newValue.toString())
                                            } catch (e: Exception) {
                                                println("🔥 ERRORE SALVATAGGIO SCORTA: ${e.message}")
                                            }
                                        }
                                    },
                                    // 🚀 INIZIO BLOCCO AGGIUNTO PER IL CLOUD DELLO SCUDO
                                    emergencyTargetCents = emergencyTargetCents,
                                    onUpdateEmergencyTarget = { newValue ->
                                        // 1. Aggiorna lo stato locale per la UI in tempo reale
                                        emergencyTargetCents = newValue

                                        // 2. 🚀 LASCIA FARE TUTTO A FIRESTORE!
                                        // Non usare più il database SQLite interno né le Settings locali.
                                        // Solo Firestore. Quando Firestore avrà salvato,
                                        // il LaunchedEffect in cima al file aggiornerà tutti.
                                        scope.launch(Dispatchers.Default) {
                                            try {
                                                homeViewModel.firestore.salvaTargetScudo(newValue)
                                            } catch(e: Exception) {
                                                println("🔥 ERRORE SALVATAGGIO SCUDO CLOUD: ${e.message}")
                                            }
                                        }
                                    },
                                    // 🚀 FINE BLOCCO AGGIUNTO

                                    onDismissTransaction = { updatedTx ->
                                        scope.launch {
                                            database.transactionQueries.upsert(
                                                id = updatedTx.id, accountId = updatedTx.accountId, toAccountId = updatedTx.toAccountId, fromAccountId = updatedTx.fromAccountId, amountCents = updatedTx.amountCents, type = updatedTx.type, dateEpochDay = updatedTx.dateEpochDay, categoryId = updatedTx.categoryId, description = updatedTx.description, merchantKey = updatedTx.merchantKey, subcategoryText = updatedTx.subcategoryText, logoEmoji = updatedTx.logoEmoji, logoUri = updatedTx.logoUri, isHidden = updatedTx.isHidden, isDeleted = updatedTx.isDeleted, reminderDays = updatedTx.reminderDays, createdAtEpochMs = updatedTx.createdAtEpochMs, updatedAtEpochMs = updatedTx.updatedAtEpochMs
                                            )
                                            try { homeViewModel.firestore.salva("movimenti", updatedTx.id, updatedTx) } catch (e: Exception) { }
                                        }
                                    },
                                    savingsTotalCents = 0L, hideBalances = hideBalances,
                                    onToggleHideBalances = {
                                        hideBalances = !hideBalances
                                        pendingCloudSave = true
                                    },
                                    hiddenAccountIds = hiddenAccountIds, onToggleAccountHidden = { id -> hiddenAccountIds = if (hiddenAccountIds.contains(id)) hiddenAccountIds - id else hiddenAccountIds + id },
                                    favorites = favorites, accounts = accounts, latest = transactions,
                                    onSelectActive = { id ->
                                        val newId = if (id == "Tutti i conti" || id.isBlank()) null else id
                                        activeAccountId = newId
                                        pendingCloudSave = true
                                    },
                                    activeBalanceCents = realAvailableBalance,
                                    payPeriodStart = payPeriodStart, payPeriodEnd = payPeriodEnd, totalFinancingRemainingCents = 0L,
                                    activeAccountId = activeAccountId,
                                    activeAccountLogoEmoji = activeAccount?.logoEmoji, activeAccountLogoUri = activeAccount?.logoUri,
                                    committedRecurringCents = stats.unpaidRecurringCents,
                                    committedFinancingCents = stats.unpaidFinancingCents,
                                    recurringItems = recurringItems, financingItems = financings,
                                    onPopupStateChanged = { isScreenPopupOpen = it },
                                    onHideBalancesChange = { hideBalances = it; pendingCloudSave = true },
                                    onOpenRecurring = { screen = Screen.RECURRING }, onGenerateRecurring = {},
                                    onGenerateFinancing = {}, onOpenFinancings = { screen = Screen.FINANCINGS },
                                    onOpenMovementsListForAccount = { id -> activeAccountId = id; pendingCloudSave = true; screen = Screen.TRANSACTIONS },
                                    onQuickAddActive = { type -> initialTxType = type; showAddTxDialog = true },
                                    onQuickAddSavings = {},
                                    onQuickAddForAccount = { accountId, type -> activeAccountId = accountId; initialTxType = type; showAddTxDialog = true },
                                    onApplyFavorite = { fav ->
                                        val nowMs = Clock.System.now().toEpochMilliseconds()
                                        val txToday = Clock.System.todayIn(TimeZone.currentSystemDefault()).toEpochDays().toLong()
                                        val id = "tx_fav_${nowMs}"
                                        val tx = TransactionEntity(id, activeAccountId ?: accounts.firstOrNull()?.id, null, null, fav.amountCents, "EXPENSE", txToday, fav.categoryId, fav.description ?: "Movimento Rapido", "", "", fav.logoEmoji, fav.logoUri, false, false, reminderDays = 0L,nowMs, nowMs)
                                        handleSaveTransaction(tx)
                                    },
                                    onRequestDeleteFavorite = { fav -> homeViewModel.deleteFavorite(fav.id) },
                                    onCreateAccount = { accountToEdit = null; showAccountDialog = true },
                                    onEditAccount = { acc -> accountToEdit = acc; showAccountDialog = true },
                                    onRequestDelete = { account -> homeViewModel.deleteAccount(account.id) },
                                    onUpdateAccount = { updatedAcc ->
                                        scope.launch {
                                            database.accountQueries.upsert(updatedAcc.id, updatedAcc.name, updatedAcc.logoEmoji, updatedAcc.logoUri, updatedAcc.isVisible, updatedAcc.isHidden, updatedAcc.isSavings, updatedAcc.isArchived, updatedAcc.isDeleted, updatedAcc.createdAtEpochMs, Clock.System.now().toEpochMilliseconds())
                                            try {
                                                homeViewModel.firestore.salva("conti", updatedAcc.id, updatedAcc)
                                            } catch (e: Exception) {
                                                println("🔥 ERRORE SALVATAGGIO CONTO CLOUD: ${e.message}")
                                            }
                                        }
                                    },
                                    onOpenSettings = { showSettingsDialog = true },
                                    onForceSync = { homeViewModel.sincronizzaTutto() },
                                    onNukeAllData = { homeViewModel.nukeAllData() },
                                    onOpenTrash = { showTrashScreen = true },
                                    onOpenCalculator = { showGlobalCalculator = true },
                                    cleanName = userName, homeCardStepPx = 0f,
                                    isGlobalPopupOpen = (showGlobalCalculator && !isCalculatorMinimized),
                                    categories = categories, savingsAccountIds = accounts.filter { it.isSavings }.map { it.id }.toSet(),
                                    stats = stats,
                                    onAvailableBalanceCalculated = { saldoDellaCardGrande = it }, accountingBalancesMap = accountingBalancesMap,
                                    savingsGoals = savingsGoals,
                                    piggyBanks = piggyBanks,
                                    onPayRecurringEarly = { rec ->
                                        homeViewModel.payRecurringEarly(rec)
                                    },
                                    onUndoRecurringPayment = { rec ->
                                        homeViewModel.undoRecurringPayment(rec)
                                    },
                                    onPayFinancingEarly = { fin ->
                                        val nowMs = Clock.System.now().toEpochMilliseconds()
                                        val start = try { LocalDate.fromEpochDays(fin.startEpochDay.toInt()) } catch(e: Exception) { today }

                                        // 🚀 FIX 1: QUI ESTRAIAMO IL GIORNO CORRETTO DAL TAG!
                                        val match = Regex("\\[DAY:(\\d+)\\]").find(fin.purpose ?: "")
                                        val targetDay = match?.groupValues?.get(1)?.toIntOrNull() ?: start.dayOfMonth

                                        var targetMonth = today.monthNumber
                                        var targetYear = today.year

                                        if (today.dayOfMonth >= 27) {
                                            if (targetDay < 27) {
                                                targetMonth++
                                                if (targetMonth > 12) {
                                                    targetMonth = 1
                                                    targetYear++
                                                }
                                            }
                                        }

                                        // 🚀 SLITTAMENTO WEEKEND DURANTE IL PAGAMENTO ANTICIPATO IN APP.KT
                                        val dataScadenza = getShiftedDueDate(targetDay, targetMonth, targetYear)
                                        val msScadenza = dataScadenza.toEpochDays().toLong() * 86400000L

                                        val mesiItaliani = listOf("Gennaio", "Febbraio", "Marzo", "Aprile", "Maggio", "Giugno", "Luglio", "Agosto", "Settembre", "Ottobre", "Novembre", "Dicembre")
                                        val meseStr = mesiItaliani.getOrNull(targetMonth - 1) ?: ""

                                        val cleanPurpose = fin.purpose?.replace(Regex("\\[DAY:\\d+\\]"), "")?.trim()
                                        val baseNote = cleanPurpose?.takeIf { it.isNotBlank() } ?: fin.name?.trim() ?: "Rata Finanziamento"
                                        val cleanCreditor = (fin.creditorName ?: fin.name)?.trim() ?: "Rata"

                                        val totalInstallment = fin.installmentAmountCents + (fin.commissionCents ?: 0L)
                                        val newTx = TransactionEntity(
                                            id = "tx_fin_early_${nowMs}_${kotlin.random.Random.nextInt(1000)}", accountId = fin.accountId ?: activeAccountId ?: accounts.firstOrNull()?.id ?: "", toAccountId = null, fromAccountId = null, amountCents = totalInstallment, type = "EXPENSE",
                                            dateEpochDay = today.toEpochDays().toLong(), // 🚀 FORZATO A OGGI
                                            categoryId = fin.categoryId ?: "",
                                            description = "$baseNote $meseStr [fin:${fin.id}] [manual]", // 🚀 AGGIUNTO [manual]
                                            merchantKey = cleanCreditor, subcategoryText = "Rata Debito", logoEmoji = fin.logoEmoji, logoUri = fin.logoUri, isHidden = false, isDeleted = false, reminderDays = -1L, createdAtEpochMs = nowMs, updatedAtEpochMs = nowMs
                                        )
                                        handleSaveTransaction(newTx)
                                        val nuovoResiduo = (fin.remainingAmountCents - fin.installmentAmountCents).coerceAtLeast(0L)
                                        homeViewModel.saveFinancing(fin.copy(remainingAmountCents = nuovoResiduo, updatedAtEpochMs = msScadenza))
                                    },
                                    onUndoFinancingPayment = { fin ->
                                        val marker = "[fin:${fin.id}]"
                                        val txToDelete = transactions.filter { !it.isDeleted && (it.merchantKey?.contains(marker) == true || it.description?.contains(marker) == true) }
                                            .maxByOrNull { it.createdAtEpochMs }

                                        if (txToDelete != null) {
                                            homeViewModel.deleteTransaction(txToDelete.id)
                                        }

                                        val nuovoResiduo = fin.remainingAmountCents + fin.installmentAmountCents
                                        homeViewModel.saveFinancing(fin.copy(
                                            remainingAmountCents = nuovoResiduo,
                                            updatedAtEpochMs = Clock.System.now().toEpochMilliseconds()
                                        ))
                                    },
                                    onOpenDebtManager = { screen = Screen.DEBTS },
                                    onSaveTransaction = { tx -> handleSaveTransaction(tx) },
                                    onProcessBankData = { amount, merchant, isIncome ->
                                        initialTxType = if (isIncome) "INCOME" else "EXPENSE"
                                        capturedBankData = BankNotificationData(amount = amount, merchant = merchant, isIncome = isIncome)
                                        showAddTxDialog = true
                                    },
                                )
                            }
                            Screen.STATS -> {
                                StatsScreen(
                                    db = database,
                                    availableBalanceCents = currentBalance,
                                    hideBalances = hideBalances, favorites = favorites,
                                    latest = transactions, categories = categories, activeAccountId = activeAccountId, recurringItems = recurringItems,
                                    financingItems = financings, accounts = accounts,
                                    salaryDay = salaryDay,
                                    decemberSalaryDay = decemberSalaryDay,
                                    anticipateWeekends = anticipateWeekends,
                                    piggyBanks = piggyBanks,
                                    bankAdjustmentCents = homeViewModel.bankAdjustmentCents.collectAsState().value,
                                    onBankAdjustmentChanged = { newAdjustment ->
                                        homeViewModel.saveBankAdjustment(newAdjustment)
                                    },
                                    onCreateCategory = { catName ->
                                        val norm = catName.lowercase().replace("\\s+".toRegex(), "_").replace("[^a-z0-9_]+".toRegex(), "")
                                        val newId = "cat_$norm"
                                        val now = Clock.System.now().toEpochMilliseconds()
                                        homeViewModel.saveCategory(CategoryEntity(newId, catName, false, now, now))
                                    },
                                    onAddIncome = { initialTxType = "INCOME"; showAddTxDialog = true },
                                    onAddExpense = { initialTxType = "EXPENSE"; showAddTxDialog = true },
                                    onAddTransfer = { initialTxType = "TRANSFER"; showAddTxDialog = true },
                                    onSelectActiveAccount = { id ->
                                        activeAccountId = id
                                        pendingCloudSave = true
                                    },
                                    onPopupStateChanged = { isScreenPopupOpen = it },
                                    savingsGoals = savingsGoals,
                                    onOpenGlobalSearchResult = { query, txId -> globalSearchQuery = query; targetTxId = txId; screen = Screen.TRANSACTIONS },
                                    onBack = { screen = Screen.HOME },
                                    safetyBufferCents = safetyBufferCents
                                )
                            }
                            Screen.SAVINGS -> {
                                SavingsAndBudgetScreen(
                                    db = database, activeAccountId = activeAccountId, accounts = accounts,
                                    accountingBalancesMap = accountingBalancesMap,
                                    availableBalanceCents = saldoDellaCardGrande,
                                    latestTx = transactions,
                                    budgets = budgets, savingsGoals = savingsGoals, categories = categories, spentByCategoryCents = spentByCategoryMap,piggyBanks = piggyBanks,
                                    onSavePiggyBank = { bank -> homeViewModel.savePiggyBank(bank) },

                                    onAddBudget = { budgetToEdit = null; showBudgetDialog = true },
                                    onAddSavingsGoal = { savingsGoalToEdit = null; showSavingsGoalDialog = true },
                                    onEditBudget = { budget -> budgetToEdit = budget; showBudgetDialog = true },
                                    onEditSavingsGoal = { goal -> savingsGoalToEdit = goal; showSavingsGoalDialog = true },
                                    onSaveGoal = { goal -> homeViewModel.saveSavingsGoal(goal) },
                                    onSaveTransaction = { tx -> handleSaveTransaction(tx) },
                                    onDeletePiggyBank = { id -> homeViewModel.deletePiggyBank(id) },
                                    autoSweepEnabled = autoSweepEnabled,
                                    sweepDestination = sweepDestination,
                                    onToggleAutoSweep = {
                                        autoSweepEnabled = it
                                        pendingCloudSave = true
                                    },
                                    onChangeSweepDestination = {
                                        sweepDestination = it
                                        pendingCloudSave = true
                                    },
                                    payPeriodEnd = payPeriodEnd,
                                    onPopupStateChanged = { isScreenPopupOpen = it },
                                    hideBalances = hideBalances
                                )
                            }

                            Screen.RECURRING -> {
                                RecurringScreen(
                                    recurringItems = recurringItems,
                                    transactions = transactions,
                                    accounts = accounts,
                                    categories = categories,
                                    hideBalances = hideBalances,
                                    payPeriodEnd = payPeriodEnd,
                                    onToggleHideBalances = {
                                        hideBalances = !hideBalances
                                        pendingCloudSave = true
                                    },
                                    onAddClick = { recurringToEdit = null; showRecurringDialog = true },
                                    onEditClick = { item -> recurringToEdit = item; showRecurringDialog = true },
                                    onDeleteClick = { item -> homeViewModel.deleteRecurring(item.id) },
                                    onToggleEnable = { item, isEnabled ->
                                        scope.launch {
                                            val nowMs = Clock.System.now().toEpochMilliseconds()
                                            val todayDate = Clock.System.todayIn(TimeZone.currentSystemDefault())

                                            val updatedItem = if (isEnabled) {
                                                // 🚀 RIATTIVAZIONE: Calcoliamo la prossima data utile partendo da OGGI
                                                val freq = item.frequency ?: "Mensile"
                                                val nextDueDate = if (freq.startsWith("CUSTOM_")) {
                                                    val parts = freq.split("_")
                                                    val giorni = parts.getOrNull(1)?.toIntOrNull() ?: 30
                                                    var prossima = todayDate.plus(DatePeriod(days = giorni))
                                                    if (parts.getOrNull(2) != "NOSKIP") {
                                                        if (prossima.dayOfWeek == DayOfWeek.SATURDAY) prossima = prossima.plus(DatePeriod(days = 2))
                                                        else if (prossima.dayOfWeek == DayOfWeek.SUNDAY) prossima = prossima.plus(DatePeriod(days = 1))
                                                    }
                                                    prossima
                                                } else {
                                                    val targetDay = item.dayOfMonth.toInt()
                                                    var targetMonth = todayDate.monthNumber
                                                    var targetYear = todayDate.year

                                                    // Se il giorno del mese è già passato, slittiamo al mese successivo
                                                    if (todayDate.dayOfMonth > targetDay) {
                                                        targetMonth++
                                                        if (targetMonth > 12) {
                                                            targetMonth = 1
                                                            targetYear++
                                                        }
                                                    }

                                                    var d = targetDay
                                                    var data: LocalDate? = null
                                                    // Evita crash per date inesistenti (es. 31 Febbraio)
                                                    while (data == null && d > 0) {
                                                        try { data = LocalDate(targetYear, targetMonth, d) } catch (e: Exception) { d-- }
                                                    }
                                                    data ?: todayDate
                                                }

                                                item.copy(
                                                    isEnabled = true,
                                                    nextEpochDay = nextDueDate.toEpochDays().toLong(),
                                                    updatedAtEpochMs = nowMs
                                                )
                                            } else {
                                                // 🚀 SOSPENSIONE: Spegniamo e basta
                                                item.copy(isEnabled = false, updatedAtEpochMs = nowMs)
                                            }

                                            // 🚀 FIX CRITICO: USIAMO saveRecurring INVECE DI updateRecurring!
                                            homeViewModel.saveRecurring(updatedItem)
                                        }
                                    },
                                    onGenerateRecurring = { scope.launch { AutomationEngine.processPendingAutomations(database, homeViewModel.firestore) } },
                                    isGenerating = false,
                                    onSaveTransaction = { tx -> handleSaveTransaction(tx) },
                                    onUpdate = { updatedItem ->
                                        scope.launch {
                                            // 🚀 FIX CRITICO: USIAMO saveRecurring!
                                            homeViewModel.saveRecurring(updatedItem)
                                        }
                                    },
                                    onLiquidateCycle = { rec, accumulatedCents, actualCents, selectedEpochDay, riavvia -> // 🚀 Aggiunto selectedEpochDay
                                        scope.launch {
                                            val nowMs = Clock.System.now().toEpochMilliseconds()

                                            // 🚀 USIAMO LA DATA SCELTA DALL'UTENTE (Es. 30 Settembre)
                                            val liquidationDate = LocalDate.fromEpochDays(selectedEpochDay.toInt())

                                            // 🚀 0. STORICIZZAZIONE VECCHIE RATE (IL SEGRETO DEL RESET!)
                                            val txsToArchive = transactions.filter {
                                                !it.isDeleted &&
                                                        (it.description?.contains("[rec:${rec.id}]") == true || it.merchantKey?.contains("[rec:${rec.id}]") == true)
                                            }

                                            txsToArchive.forEach { oldTx ->
                                                val newDesc = oldTx.description?.replace("[rec:${rec.id}]", "[rec_old:${rec.id}]")
                                                val newKey = oldTx.merchantKey?.replace("[rec:${rec.id}]", "[rec_old:${rec.id}]")
                                                homeViewModel.saveTransaction(oldTx.copy(
                                                    description = newDesc,
                                                    merchantKey = newKey,
                                                    updatedAtEpochMs = nowMs
                                                ))
                                            }

                                            // 🚀 1. SBLOCCO FONDI ACCUMULATI (ENTRATA)
                                            if (accumulatedCents > 0L) {
                                                val unlockTx = TransactionEntity(
                                                    id = "tx_liq_unl_${nowMs}_${kotlin.random.Random.nextInt(1000)}",
                                                    accountId = rec.accountId ?: activeAccountId ?: accounts.firstOrNull { !it.isDeleted }?.id ?: "",
                                                    toAccountId = null, fromAccountId = null, amountCents = accumulatedCents, type = "INCOME",
                                                    dateEpochDay = selectedEpochDay, // 👈 USIAMO LA TUA DATA
                                                    categoryId = rec.categoryId ?: "default",
                                                    description = "Sblocco fondi ciclo", merchantKey = rec.name ?: "Ciclo",
                                                    subcategoryText = "Sblocco Accantonamento", logoEmoji = "🔓", logoUri = null,
                                                    isHidden = false, isDeleted = false, reminderDays = -1L, createdAtEpochMs = nowMs, updatedAtEpochMs = nowMs
                                                )
                                                handleSaveTransaction(unlockTx)
                                            }

                                            // 🚀 2. PAGAMENTO DELLA TASSA REALE (USCITA)
                                            if (actualCents > 0L) {
                                                val payTx = TransactionEntity(
                                                    id = "tx_liq_pay_${nowMs}_${kotlin.random.Random.nextInt(1000)}",
                                                    accountId = rec.accountId ?: activeAccountId ?: accounts.firstOrNull { !it.isDeleted }?.id ?: "",
                                                    toAccountId = null, fromAccountId = null, amountCents = actualCents, type = "EXPENSE",
                                                    dateEpochDay = selectedEpochDay, // 👈 USIAMO LA TUA DATA
                                                    categoryId = rec.categoryId ?: "default",
                                                    description = "Liquidazione ciclo", merchantKey = rec.name ?: "Ciclo",
                                                    subcategoryText = "Pagamento Reale", logoEmoji = rec.logoEmoji, logoUri = rec.logoUri,
                                                    isHidden = false, isDeleted = false, reminderDays = -1L, createdAtEpochMs = nowMs + 1, updatedAtEpochMs = nowMs + 1
                                                )
                                                handleSaveTransaction(payTx)
                                            }

                                            // 🚀 3. RESET DEL CICLO E SLITTAMENTO DATA
                                            // Ora si slitta dalla tua data! Se imposti il 30 Settembre, ripartirà in Ottobre!
                                            if (riavvia) {
                                                val freq = rec.frequency ?: "Mensile"
                                                val nextDueDate = if (freq.startsWith("CUSTOM_")) {
                                                    val parts = freq.split("_")
                                                    val giorni = parts.getOrNull(1)?.toIntOrNull() ?: 30
                                                    var prossima = liquidationDate.plus(DatePeriod(days = giorni))
                                                    if (parts.getOrNull(2) != "NOSKIP") {
                                                        if (prossima.dayOfWeek == DayOfWeek.SATURDAY) prossima = prossima.plus(DatePeriod(days = 2))
                                                        else if (prossima.dayOfWeek == DayOfWeek.SUNDAY) prossima = prossima.plus(DatePeriod(days = 1))
                                                    }
                                                    prossima
                                                } else {
                                                    val targetDay = rec.dayOfMonth.toInt()
                                                    var targetMonth = liquidationDate.monthNumber
                                                    var targetYear = liquidationDate.year

                                                    if (liquidationDate.dayOfMonth >= targetDay) {
                                                        targetMonth++
                                                        if (targetMonth > 12) {
                                                            targetMonth = 1
                                                            targetYear++
                                                        }
                                                    }
                                                    var d = targetDay
                                                    var data: LocalDate? = null
                                                    while (data == null && d > 0) {
                                                        try { data = LocalDate(targetYear, targetMonth, d) } catch (e: Exception) { d-- }
                                                    }
                                                    data ?: liquidationDate
                                                }

                                                homeViewModel.updateRecurring(rec.copy(
                                                    startEpochDay = liquidationDate.plus(DatePeriod(days = 1)).toEpochDays().toLong(),
                                                    nextEpochDay = nextDueDate.toEpochDays().toLong(),
                                                    isEnabled = true,
                                                    updatedAtEpochMs = nowMs
                                                ))
                                            } else {
                                                homeViewModel.updateRecurring(rec.copy(
                                                    startEpochDay = liquidationDate.plus(DatePeriod(days = 1)).toEpochDays().toLong(),
                                                    isEnabled = false,
                                                    updatedAtEpochMs = nowMs
                                                ))
                                            }
                                        }
                                    },
                                    onPayRecurringEarly = { rec ->
                                        scope.launch {
                                            val nowMs = Clock.System.now().toEpochMilliseconds()
                                            val todayDate = Clock.System.todayIn(TimeZone.currentSystemDefault())
                                            val isTransfer = rec.type == "TRANSFER" || rec.toAccountId != null
                                            val isIncome = rec.type == "INCOME"

                                            // 🚀 1. Creiamo noi la transazione fisica in modo perfetto
                                            val newTx = TransactionEntity(
                                                id = "tx_rec_early_${nowMs}_${kotlin.random.Random.nextInt(1000)}",
                                                accountId = rec.accountId ?: activeAccountId ?: accounts.firstOrNull { !it.isDeleted }?.id ?: "",
                                                toAccountId = rec.toAccountId,
                                                fromAccountId = if (isTransfer) rec.accountId else null,
                                                amountCents = rec.amountCents,
                                                type = if (isTransfer) "TRANSFER" else if (isIncome) "INCOME" else "EXPENSE",
                                                dateEpochDay = todayDate.toEpochDays().toLong(),
                                                categoryId = rec.categoryId ?: "default",
                                                // 🚀 ECCO IL TAG MAGICO QUI SOTTO:
                                                description = "${rec.notes?.takeIf { it.isNotBlank() } ?: rec.name ?: "Spesa Fissa"} [rec:${rec.id}] [manual]",
                                                merchantKey = rec.name ?: "Spesa Fissa",
                                                subcategoryText = if (isTransfer) "Giroconto" else if (isIncome) "Entrata Fissa" else "Spesa Fissa",
                                                logoEmoji = rec.logoEmoji,
                                                logoUri = rec.logoUri,
                                                isHidden = false,
                                                isDeleted = false,
                                                reminderDays = -1L,
                                                createdAtEpochMs = nowMs,
                                                updatedAtEpochMs = nowMs
                                            )
                                            handleSaveTransaction(newTx)

                                            // 🚀 2. Calcoliamo la prossima scadenza
                                            val freq = rec.frequency ?: "Mensile"
                                            val nextDueDate = if (freq.startsWith("CUSTOM_")) {
                                                val parts = freq.split("_")
                                                val giorni = parts.getOrNull(1)?.toIntOrNull() ?: 30
                                                var prossima = todayDate.plus(DatePeriod(days = giorni))
                                                if (parts.getOrNull(2) != "NOSKIP") {
                                                    if (prossima.dayOfWeek == DayOfWeek.SATURDAY) prossima = prossima.plus(DatePeriod(days = 2))
                                                    else if (prossima.dayOfWeek == DayOfWeek.SUNDAY) prossima = prossima.plus(DatePeriod(days = 1))
                                                }
                                                prossima
                                            } else {
                                                val targetDay = rec.dayOfMonth.toInt()
                                                var targetMonth = todayDate.monthNumber
                                                var targetYear = todayDate.year

                                                if (todayDate.dayOfMonth >= targetDay) {
                                                    targetMonth++
                                                    if (targetMonth > 12) {
                                                        targetMonth = 1
                                                        targetYear++
                                                    }
                                                }
                                                var d = targetDay
                                                var data: LocalDate? = null
                                                while (data == null && d > 0) {
                                                    try { data = LocalDate(targetYear, targetMonth, d) } catch (e: Exception) { d-- }
                                                }
                                                data ?: todayDate
                                            }

                                            // 🚀 3. Aggiorniamo il DB spostando SOLO la prossima data, lasciando INTATTA l'ancora di inizio ciclo!
                                            homeViewModel.saveRecurring(rec.copy(
                                                nextEpochDay = nextDueDate.toEpochDays().toLong(),
                                                updatedAtEpochMs = nowMs
                                            ))
                                        }
                                    },
                                    onPopupStateChanged = { isScreenPopupOpen = it }
                                )
                            }
                            Screen.TRANSACTIONS -> {
                                TransactionsScreen(
                                    db = database, allTransactions = transactions,
                                    availableBalanceCents = realAvailableBalance,
                                    hideBalances = hideBalances, hiddenAccountIds = hiddenAccountIds, latest = transactions,
                                    payPeriodStart = payPeriodStart,
                                    payPeriodEnd = payPeriodEnd,
                                    onEdit = { tx -> transactionToEdit = tx; showEditTxDialog = true },
                                    onDelete = { tx -> homeViewModel.deleteTransaction(tx.id) },
                                    onDeleteMultiple = { txs -> homeViewModel.deleteMultipleTransactions(txs) },
                                    onAddMovement = { type -> initialTxType = type; showAddTxDialog = true },
                                    onAddFavorite = { tx ->
                                        val nowMs = Clock.System.now().toEpochMilliseconds()
                                        val id = "fav_${nowMs}"
                                        val newFav = FavoriteTemplateEntity(id, tx.description, tx.amountCents, tx.categoryId, tx.logoEmoji, tx.logoUri, false, nowMs, nowMs)
                                        scope.launch {
                                            database.favoriteTemplateQueries.upsert(id, tx.description, tx.amountCents, tx.categoryId, tx.logoEmoji, tx.logoUri, false, nowMs, nowMs)
                                            homeViewModel.firestore.salva("preferiti", id, newFav)
                                        }
                                    },
                                    onHide = { tx -> homeViewModel.saveTransaction(tx) },
                                    onUnhide = { tx -> homeViewModel.saveTransaction(tx) },
                                    onSaveTransaction = { tx -> handleSaveTransaction(tx) },
                                    accounts = accounts, accountBalancesById = accountingBalancesMap, categories = categories, activeAccountId = activeAccountId, financings = financings,
                                    recurringItems = recurringItems,
                                    savingsGoals = savingsGoals,
                                    piggyBanks = piggyBanks, // 🚀 3. AGGIUNGI QUESTA RIGA QUI!
                                    globalSearchQuery = globalSearchQuery, targetTxId = targetTxId,
                                    onTargetTxConsumed = { globalSearchQuery = ""; targetTxId = null }, hiddenJumpRequest = 0, hiddenJumpActive = false,
                                    onToggleHideBalances = {
                                        hideBalances = !hideBalances
                                        pendingCloudSave = true
                                    },
                                    fileExporter = fileExporter,
                                    onPopupStateChanged = { isScreenPopupOpen = it },
                                    onBack = { screen = Screen.HOME },
                                    onLogoutRequest = {
                                        scope.launch {
                                            dev.gitlive.firebase.Firebase.auth.signOut()
                                        }
                                    }
                                )
                            }
                            Screen.FINANCINGS -> {
                                FinancingScreen(
                                    viewModel = homeViewModel,
                                    db = database, accounts = accounts, categories = categories, financings = financings, hideAmounts = hideBalances,
                                    activeAccountId = activeAccountId, onChanged = { }, generateTick = 0, createTick = 0, onCreateTickConsumed = {},
                                    onPopupStateChanged = { isScreenPopupOpen = it }
                                )
                            }
                        }
                    }

                    // 🚀 DIALOGS LOCALI
                    if (showSettingsDialog) {
                        SettingsDialog(
                            userName = userName,
                            salaryDay = salaryDay,
                            decemberSalaryDay = decemberSalaryDay,
                            anticipateWeekends = anticipateWeekends,
                            hideBalances = hideBalances,
                            deadlineHour = deadlineHour,
                            deadlineMinute = deadlineMinute,
                            deadlineEnabled = deadlineEnabled,
                            summaryHour = summaryHour,
                            summaryMinute = summaryMinute,
                            summaryEnabled = summaryEnabled,
                            themeMode = themeMode,
                            appLockEnabled = appLockEnabled,
                            backupFolderUri = null,
                            lastBackupEpochMs = 0L,
                            onThemeModeChange = { themeMode = it; pendingCloudSave = true },
                            onUserNameChange = { userName = it },
                            onSalaryDayChange = { salaryDay = it },
                            onDecemberSalaryDayChange = { decemberSalaryDay = it },
                            appBackgroundUri = appBackgroundUri,
                            onSaveAppBackgroundUri = { uri ->
                                if (uri != null && uri.isNotBlank()) {
                                    settings.putString("app_background_uri", uri)
                                    localBackgroundUri.value = uri
                                } else {
                                    settings.remove("app_background_uri")
                                    localBackgroundUri.value = null
                                }
                                scope.launch { homeViewModel.firestore.salvaAppBackgroundUri(uri) }
                            },
                            onAnticipateWeekendsChange = { anticipateWeekends = it },
                            onHideBalancesChange = { hideBalances = it; pendingCloudSave = true },
                            onAppLockEnabledChange = { enabled -> appLockEnabled = enabled; settings.putBoolean("app_lock_enabled", enabled); pendingCloudSave = true },
                            onPickBackupFolder = { },
                            onQuickBackupToFolder = { },
                            onBackupRequest = { },
                            onRestoreRequest = { },
                            onDeadlineSettingsChange = { h, m, enabled ->
                                deadlineHour = h; deadlineMinute = m; deadlineEnabled = enabled
                                if (enabled) scheduler.scheduleDeadlineReminder(h, m) else scheduler.cancelDeadlineReminder()
                                pendingCloudSave = true
                            },
                            onSummarySettingsChange = { h, m, enabled ->
                                summaryHour = h; summaryMinute = m; summaryEnabled = enabled
                                if (enabled) scheduler.scheduleSummaryReminder(h, m) else scheduler.cancelSummaryReminder()
                                pendingCloudSave = true
                            },
                            onDismiss = { showSettingsDialog = false }
                        )
                    }

                    if (showAddTxDialog) {
                        AddOrTransferDialog(
                            viewModel = homeViewModel, db = database, initialMode = initialTxType, saldoDisponibile = saldoDellaCardGrande,
                            categories = categories, accounts = accounts, latest = transactions, activeAccountId = activeAccountId,
                            initialBankData = capturedBankData ?: initialBankData,
                            onBankDataConsumed = { if (capturedBankData != null) capturedBankData = null else onBankDataConsumed() },
                            onDismiss = { showAddTxDialog = false; capturedBankData = null },
                            onSaveTx = { tx ->
                                // 🚀 Chiama il motore automatico che ora fa tutto da solo, senza chiedere conferme!
                                handleSaveTransaction(tx)
                                showAddTxDialog = false
                                capturedBankData = null
                            },
                            financings = financings, recurringItems = recurringItems, savingsGoals = savingsGoals, piggyBanks = piggyBanks
                        )
                    }

                    if (showEditTxDialog && transactionToEdit != null) {
                        EditTransactionDialog(
                            viewModel = homeViewModel, db = database, original = transactionToEdit!!, saldoDisponibile = saldoDellaCardGrande,
                            categories = categories, accounts = accounts, financings = financings, recurringItems = recurringItems,
                            savingsGoals = savingsGoals, onDismiss = { showEditTxDialog = false; transactionToEdit = null },
                            onSaved = { showEditTxDialog = false; transactionToEdit = null }
                        )
                    }

                    if (showAccountDialog) {
                        val idDaSalvare = accountToEdit?.id ?: "acc_${Clock.System.now().toEpochMilliseconds()}"
                        val dataCreazione = accountToEdit?.createdAtEpochMs ?: Clock.System.now().toEpochMilliseconds()
                        val currentHidden = accountToEdit?.isHidden ?: false
                        val currentArchived = accountToEdit?.isArchived ?: false
                        val currentDeleted = accountToEdit?.isDeleted ?: false

                        AccountCreateOrEditDialog(
                            initial = accountToEdit, existingAccounts = accounts, title = if (accountToEdit != null) "Modifica Conto" else "Nuovo Conto",
                            onDismiss = { showAccountDialog = false; accountToEdit = null },
                            onSave = { name, visible, isSavings, emoji, uri ->
                                scope.launch {
                                    val now = Clock.System.now().toEpochMilliseconds()
                                    database.accountQueries.upsert(idDaSalvare, name, emoji, uri, visible, currentHidden, isSavings, currentArchived, currentDeleted, dataCreazione, now)
                                    val nuovoConto = AccountEntity(idDaSalvare, name, emoji, uri ?: "", visible, currentHidden, isSavings, currentArchived, currentDeleted, dataCreazione, now)
                                    homeViewModel.firestore.salva("conti", idDaSalvare, nuovoConto)
                                }
                                showAccountDialog = false; accountToEdit = null
                            }
                        )
                    }

                    if (showRecurringDialog) {
                        RecurringExpenseDialog(
                            db = database, initial = recurringToEdit, categories = categories, accounts = accounts, preferredAccountId = activeAccountId,
                            onDismiss = { showRecurringDialog = false; recurringToEdit = null },
                            onSave = { item -> homeViewModel.saveRecurring(item); showRecurringDialog = false; recurringToEdit = null },
                            onCategoryCreate = { cat -> homeViewModel.saveCategory(cat) }
                        )
                    }

                    if (showBudgetDialog) {
                        BudgetDialog(
                            db = database, initial = budgetToEdit, categories = categories,
                            onDismiss = { showBudgetDialog = false; budgetToEdit = null },
                            onDelete = { categoryId -> homeViewModel.deleteBudget(categoryId); showBudgetDialog = false; budgetToEdit = null },
                            onSave = { budget -> homeViewModel.saveBudget(budget); showBudgetDialog = false; budgetToEdit = null },
                            onCategoryCreate = { cat -> homeViewModel.saveCategory(cat) }
                        )
                    }

                    if (showSavingsGoalDialog) {
                        SavingsGoalDialog(
                            initial = savingsGoalToEdit, onDismiss = { showSavingsGoalDialog = false; savingsGoalToEdit = null },
                            onDelete = { goalId -> homeViewModel.deleteSavingsGoal(goalId); showSavingsGoalDialog = false; savingsGoalToEdit = null },
                            onSave = { goal -> homeViewModel.saveSavingsGoal(goal); showSavingsGoalDialog = false; savingsGoalToEdit = null }
                        )
                    }


                    if (showTrashScreen) { TrashScreen(db = database, viewModel = homeViewModel, onBack = { showTrashScreen = false }) }
                } // Chiude il Box con weight(1f)
            } // Chiude la Column principale

            if (showGlobalCalculator) {
                if (isCalculatorMinimized) {
                    FloatingCalculatorPill(
                        currentValue = calculatorValue,
                        onExpand = { isCalculatorMinimized = false }
                    )
                } else {
                    CalculatorDialog(
                        onDismiss = { showGlobalCalculator = false; isCalculatorMinimized = false },
                        onMinimize = { isCalculatorMinimized = true },
                        onValueChange = { calculatorValue = it },
                        onResultConfirmed = { risultato ->
                            clipboardManager.setText(AnnotatedString(risultato))
                            showGlobalCalculator = false
                            isCalculatorMinimized = false
                            scope.launch { snackbarHostState.showSnackbar("Copiato negli appunti: $risultato", duration = SnackbarDuration.Short) }
                        }
                    )
                }
            }

        if (showNukePrompt) {
            AlertDialog(
                onDismissRequest = { showNukePrompt = false }, shape = RoundedCornerShape(24.dp), containerColor = MaterialTheme.colorScheme.surface,
                title = { Text("ATTENZIONE!", style = MaterialTheme.typography.titleLarge.copy(fontWeight = FontWeight.Bold), color = MaterialTheme.colorScheme.error) },
                text = { Text("Sei sicuro di voler eliminare TUTTI i conti, i movimenti e i debiti?\nL'operazione è irreversibile.", style = MaterialTheme.typography.bodyMedium) },
                confirmButton = { TextButton(onClick = { homeViewModel.nukeAllData(); showNukePrompt = false; scope.launch { snackbarHostState.showSnackbar("Dati eliminati.") } }) { Text("DISTRUGGI TUTTO", color = MaterialTheme.colorScheme.error, fontWeight = FontWeight.Bold) } },
                dismissButton = { TextButton(onClick = { showNukePrompt = false }) { Text("ANNULLA", color = MaterialTheme.colorScheme.onSurfaceVariant) } }
            )
        }

        if (showGlobalNotifications) {
            ModalBottomSheet(
                onDismissRequest = { showGlobalNotifications = false },
                sheetState = notificationSheetState,
                containerColor = MaterialTheme.colorScheme.surface,
                shape = RoundedCornerShape(topStart = 24.dp, topEnd = 24.dp)
            ) {
                Column(modifier = Modifier.fillMaxWidth().padding(bottom = 32.dp, start = 24.dp, end = 24.dp)) {
                    Row(modifier = Modifier.fillMaxWidth(), horizontalArrangement = Arrangement.SpaceBetween, verticalAlignment = Alignment.CenterVertically) {
                        Text("Centro Notifiche", style = MaterialTheme.typography.headlineSmall.copy(fontWeight = FontWeight.Bold), color = MaterialTheme.colorScheme.onSurface)
                        if (upcomingAlerts.isNotEmpty()) {
                            TextButton(onClick = {
                                upcomingAlerts.forEach { (_, tx) ->
                                    val updatedTx = tx.copy(reminderDays = -1L, updatedAtEpochMs = Clock.System.now().toEpochMilliseconds())
                                    homeViewModel.saveTransaction(updatedTx)
                                }
                                dismissedNotificationIds = dismissedNotificationIds + upcomingAlerts.map { it.second.id }.toSet()
                                if (bankNotifs.isEmpty()) showGlobalNotifications = false
                            }) { Text("Svuota scadenze", color = MaterialTheme.colorScheme.primary, fontWeight = FontWeight.Bold) }
                        }
                    }
                    Spacer(Modifier.height(16.dp))

                    if (totalNotifications == 0) {
                        Box(modifier = Modifier.fillMaxWidth().padding(vertical = 32.dp), contentAlignment = Alignment.Center) {
                            Text("Tutto tranquillo! Nessuna notifica.", color = MaterialTheme.colorScheme.onSurfaceVariant)
                        }
                    } else {
                        LazyColumn(modifier = Modifier.fillMaxWidth().heightIn(max = 500.dp)) {
                            // 1. NOTIFICHE BANCARIE DA CONFERMARE
                            if (bankNotifs.isNotEmpty()) {
                                item { Text("DA CONFERMARE (Banca)", style = MaterialTheme.typography.labelMedium.copy(fontWeight = FontWeight.Black), color = MaterialTheme.colorScheme.primary, modifier = Modifier.padding(bottom = 8.dp, top = 8.dp)) }
                                items(bankNotifs) { notif ->
                                    val isInc = notif.isIncome
                                    val color = if (isInc) Color(0xFF10B981) else MaterialTheme.colorScheme.error
                                    Row(modifier = Modifier.fillMaxWidth().padding(vertical = 12.dp), verticalAlignment = Alignment.CenterVertically) {
                                        Surface(modifier = Modifier.size(40.dp), shape = CircleShape, color = color.copy(alpha = 0.1f)) {
                                            Icon(if(isInc) Icons.Rounded.ArrowDownward else Icons.Rounded.ArrowUpward, null, tint = color, modifier = Modifier.padding(8.dp))
                                        }
                                        Column(modifier = Modifier.weight(1f).padding(horizontal = 12.dp)) {
                                            Text(notif.merchant, style = MaterialTheme.typography.bodyLarge.copy(fontWeight = FontWeight.SemiBold), maxLines = 1, overflow = TextOverflow.Ellipsis)
                                            Text("Rilevato: ${notif.amount} €", style = MaterialTheme.typography.bodySmall, color = MaterialTheme.colorScheme.onSurfaceVariant)
                                        }
                                        Row(horizontalArrangement = Arrangement.End) {
                                            IconButton(onClick = {
                                                BankNotificationCatcher.removeNotificationById(notif.id)
                                                if (BankNotificationCatcher.pendingQueue.isEmpty() && upcomingAlerts.isEmpty()) showGlobalNotifications = false
                                            }, modifier = Modifier.size(36.dp)) { Icon(Icons.Rounded.Close, "Ignora", tint = MaterialTheme.colorScheme.onSurfaceVariant) }

                                            IconButton(onClick = {
                                                showGlobalNotifications = false
                                                BankNotificationCatcher.removeNotificationById(notif.id)
                                                initialTxType = if (isInc) "INCOME" else "EXPENSE"
                                                capturedBankData = BankNotificationData(amount = notif.amount, merchant = notif.merchant)
                                                showAddTxDialog = true
                                            }, modifier = Modifier.size(36.dp)) { Icon(Icons.Rounded.Check, "Registra", tint = MaterialTheme.colorScheme.primary) }
                                        }
                                    }
                                    HorizontalDivider(color = MaterialTheme.colorScheme.outline.copy(alpha = 0.1f))
                                }
                            }

                            // 2. SCADENZE PROGRAMMATE
                            if (upcomingAlerts.isNotEmpty()) {
                                item { Text("SCADENZE PROGRAMMATE", style = MaterialTheme.typography.labelMedium.copy(fontWeight = FontWeight.Black), color = MaterialTheme.colorScheme.onSurfaceVariant, modifier = Modifier.padding(bottom = 8.dp, top = if(bankNotifs.isNotEmpty()) 16.dp else 8.dp)) }
                                items(upcomingAlerts, key = { it.second.id }) { (label, tx) ->
                                    val color = if (label == "Oggi") MaterialTheme.colorScheme.error else MaterialTheme.colorScheme.primary
                                    Row(modifier = Modifier.fillMaxWidth().padding(vertical = 12.dp), verticalAlignment = Alignment.CenterVertically) {
                                        Surface(modifier = Modifier.size(40.dp), shape = CircleShape, color = color.copy(alpha = 0.1f)) {
                                            Box(contentAlignment = Alignment.Center) { com.example.monetix.ui.components.TxLogo(tx.logoEmoji?.takeIf { it.isNotBlank() }, tx.logoUri?.takeIf { it.isNotBlank() }, tx.merchantKey ?: "S", Modifier.size(20.dp)) }
                                        }
                                        Column(modifier = Modifier.weight(1f).padding(horizontal = 16.dp)) {
                                            Text(tx.merchantKey ?: tx.description ?: "Operazione", style = MaterialTheme.typography.bodyLarge.copy(fontWeight = FontWeight.SemiBold), maxLines = 1, overflow = TextOverflow.Ellipsis)
                                            Text(label, style = MaterialTheme.typography.bodySmall, color = color)
                                        }
                                        com.example.monetix.ui.components.ModernMoneyText(cents = tx.amountCents, hideBalances = hideBalances, integerFontSize = 16.sp, decimalFontSize = 12.sp, symbolFontSize = 12.sp)

                                        IconButton(onClick = {
                                            val updatedTx = tx.copy(reminderDays = -1L, updatedAtEpochMs = Clock.System.now().toEpochMilliseconds())
                                            homeViewModel.saveTransaction(updatedTx)
                                            dismissedNotificationIds = dismissedNotificationIds + tx.id
                                        }) { Icon(Icons.Rounded.Check, "Segna letta", tint = MaterialTheme.colorScheme.onSurfaceVariant) }
                                    }
                                    HorizontalDivider(color = MaterialTheme.colorScheme.outline.copy(alpha = 0.1f))
                                }
                            }
                        }
                    }
                }
            }
        }
    }
}
}
}
}
}

@Composable
fun IconItem(
    pair: Pair<Triple<String, androidx.compose.ui.graphics.vector.ImageVector, androidx.compose.ui.graphics.vector.ImageVector>, Screen>,
    currentScreen: Screen,
    collapsed: Boolean,
    onClick: () -> Unit
) {
    val (info, itemScreen) = pair
    val (label, activeIcon, inactiveIcon) = info
    val isSelected = currentScreen == itemScreen

    val interactionSource = remember { MutableInteractionSource() }

    Column(
        modifier = Modifier
            .fillMaxSize()
            .clickable(
                interactionSource = interactionSource,
                indication = null,
                onClick = onClick
            ),
        horizontalAlignment = Alignment.CenterHorizontally,
        verticalArrangement = Arrangement.Center
    ) {
        Icon(
            imageVector = if (isSelected) activeIcon else inactiveIcon,
            contentDescription = label,
            modifier = Modifier.size(20.dp),
            tint = if (isSelected) Color.White else Color.White.copy(alpha = 0.55f)
        )
        if (!collapsed) {
            Spacer(Modifier.height(3.dp))
            Text(
                text = label,
                maxLines = 1,
                overflow = TextOverflow.Ellipsis,
                softWrap = false,
                style = MaterialTheme.typography.labelSmall.copy(
                    fontSize = 10.sp,
                    fontWeight = if (isSelected) FontWeight.Bold else FontWeight.Medium,
                    letterSpacing = (-0.1).sp
                ),
                color = if (isSelected) Color.White else Color.White.copy(alpha = 0.65f)
            )
        }
    }
}